unit View.Vendas.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  WEBLib.Lists, WEBLib.Grids, Grid.Plugins, System.StrUtils, UConstantes,
  UHelperServer, UWeb.Enum, UUtils;

type
  TFViewVendasEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbcliente_id: TLabel;
    edcliente_id: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbcaixa: TLabel;
    edcaixa: TDBEdit;
    lbcfop_cfop: TLabel;
    edcfop_cfop: TDBEdit;
    lbnumero: TLabel;
    ednumero: TDBEdit;
    lbdoc_auxiliar: TLabel;
    eddoc_auxiliar: TDBEdit;
    lbmodelo: TLabel;
    edmodelo: TDBEdit;
    lbserie: TLabel;
    edserie: TDBEdit;
    lbsubserie: TLabel;
    edsubserie: TDBEdit;
    lbdata_emissao: TLabel;
    eddata_emissao: TDBEdit;
    lbdata_saida: TLabel;
    eddata_saida: TDBEdit;
    lbvalor_acrescimos: TLabel;
    edvalor_acrescimos: TDBEdit;
    lbvalor_descontos: TLabel;
    edvalor_descontos: TDBEdit;
    lbvalor_base_calculo_icms: TLabel;
    edvalor_base_calculo_icms: TDBEdit;
    lbvalor_icms: TLabel;
    edvalor_icms: TDBEdit;
    lbvalor_base_calculo_st: TLabel;
    edvalor_base_calculo_st: TDBEdit;
    lbvalor_st: TLabel;
    edvalor_st: TDBEdit;
    lbvalor_seguro: TLabel;
    edvalor_seguro: TDBEdit;
    lbvalor_frete: TLabel;
    edvalor_frete: TDBEdit;
    lbvalor_ipi: TLabel;
    edvalor_ipi: TDBEdit;
    lbvalor_outras: TLabel;
    edvalor_outras: TDBEdit;
    lbvalor_total_itens: TLabel;
    edvalor_total_itens: TDBEdit;
    lbvalor_total: TLabel;
    edvalor_total: TDBEdit;
    lbvolumes_quantidade: TLabel;
    edvolumes_quantidade: TDBEdit;
    lbvolumes_especie: TLabel;
    edvolumes_especie: TDBEdit;
    lbvolumes_marca: TLabel;
    edvolumes_marca: TDBEdit;
    lbvolumes_peso_bruto: TLabel;
    edvolumes_peso_bruto: TDBEdit;
    lbvolumes_peso_liquido: TLabel;
    edvolumes_peso_liquido: TDBEdit;
    lbfrete_por_conta: TLabel;
    edfrete_por_conta: TDBEdit;
    lbobservacoes_credito: TLabel;
    edobservacoes_credito: TDBEdit;
    lbobservacoes: TLabel;
    edobservacoes: TDBEdit;
    lbnota_situacao: TLabel;
    ednota_situacao: TDBEdit;
    lbipi_compoe_base_icms: TLabel;
    lbfrete_compoe_base_icms: TLabel;
    lbseguro_compoe_base_icms: TLabel;
    lboutras_compoe_base_icms: TLabel;
    lbvalor_isentas: TLabel;
    edvalor_isentas: TDBEdit;
    lbdata_entrega: TLabel;
    eddata_entrega: TDBEdit;
    lbdata_movimento: TLabel;
    eddata_movimento: TDBEdit;
    lbemissao_terceiros: TLabel;
    lbchave_acesso_terceiros: TLabel;
    edchave_acesso_terceiros: TDBEdit;
    lbsimples_faturamento: TLabel;
    lbvalor_icms_desonerado: TLabel;
    edvalor_icms_desonerado: TDBEdit;
    lbvalor_ipi_devolucao: TLabel;
    edvalor_ipi_devolucao: TDBEdit;
    lbexcluiu_icms_base_pis_cofins: TLabel;
    lbvalor_fcp_st: TLabel;
    edvalor_fcp_st: TDBEdit;
    lbvalor_retido_pis: TLabel;
    edvalor_retido_pis: TDBEdit;
    lbvalor_retido_cofins: TLabel;
    edvalor_retido_cofins: TDBEdit;
    lbvalor_retido_csll: TLabel;
    edvalor_retido_csll: TDBEdit;
    lbvalor_base_calculo_irrf: TLabel;
    edvalor_base_calculo_irrf: TDBEdit;
    lbaliquota_irrf: TLabel;
    edaliquota_irrf: TDBEdit;
    lbvalor_retido_irrf: TLabel;
    edvalor_retido_irrf: TDBEdit;
    lbvalor_base_calculo_previdencia_social: TLabel;
    edvalor_base_calculo_previdencia_social: TDBEdit;
    lbaliquota_previdencia_social: TLabel;
    edaliquota_previdencia_social: TDBEdit;
    lbvalor_previdencia_social: TLabel;
    edvalor_previdencia_social: TDBEdit;
    lbexcluiu_fcp_base_pis_cofins: TLabel;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientVendasGet: TXDataWebClient;
    VendasDataset: TXDataWebDataSet;
    VendasDatasetid: TIntegerField;
    VendasDatasetaliado_id: TIntegerField;
    VendasDatasetdata_base_id: TIntegerField;
    VendasDatasetcliente_id: TIntegerField;
    VendasDatasetfuncionario_id: TIntegerField;
    VendasDatasetcaixa: TIntegerField;
    VendasDatasetcfop_cfop: TStringField;
    VendasDatasetnumero: TStringField;
    VendasDatasetdoc_auxiliar: TStringField;
    VendasDatasetmodelo: TStringField;
    VendasDatasetserie: TStringField;
    VendasDatasetsubserie: TStringField;
    VendasDatasetdata_emissao: TDateTimeField;
    VendasDatasetdata_saida: TDateTimeField;
    VendasDatasetvalor_acrescimos: TFloatField;
    VendasDatasetvalor_descontos: TFloatField;
    VendasDatasetvalor_base_calculo_icms: TFloatField;
    VendasDatasetvalor_icms: TFloatField;
    VendasDatasetvalor_base_calculo_st: TFloatField;
    VendasDatasetvalor_st: TFloatField;
    VendasDatasetvalor_seguro: TFloatField;
    VendasDatasetvalor_frete: TFloatField;
    VendasDatasetvalor_ipi: TFloatField;
    VendasDatasetvalor_outras: TFloatField;
    VendasDatasetvalor_total_itens: TFloatField;
    VendasDatasetvalor_total: TFloatField;
    VendasDatasettransportadora_id: TIntegerField;
    VendasDatasetplaca_veiculo: TStringField;
    VendasDatasetvolumes_quantidade: TIntegerField;
    VendasDatasetvolumes_especie: TStringField;
    VendasDatasetvolumes_marca: TStringField;
    VendasDatasetvolumes_peso_bruto: TFloatField;
    VendasDatasetvolumes_peso_liquido: TFloatField;
    VendasDatasetfrete_por_conta: TIntegerField;
    VendasDatasetobservacoes_credito: TStringField;
    VendasDatasetobservacoes: TStringField;
    VendasDatasetnota_situacao: TIntegerField;
    VendasDatasetipi_compoe_base_icms: TBooleanField;
    VendasDatasetfrete_compoe_base_icms: TBooleanField;
    VendasDatasetseguro_compoe_base_icms: TBooleanField;
    VendasDatasetoutras_compoe_base_icms: TBooleanField;
    VendasDatasetvalor_isentas: TFloatField;
    VendasDatasetcliente_fidelidade_id: TIntegerField;
    VendasDatasetnfe_id: TIntegerField;
    VendasDatasetnfse_id: TIntegerField;
    VendasDatasetosv_oss_id: TIntegerField;
    VendasDatasetose_oss_id: TIntegerField;
    VendasDatasetorcamentos_id: TIntegerField;
    VendasDatasetpet_vendas_id: TIntegerField;
    VendasDatasetpet_prontuarios_id: TIntegerField;
    VendasDatasetdata_entrega: TDateTimeField;
    VendasDatasetdata_movimento: TDateTimeField;
    VendasDatasetnome_consumidor_final: TStringField;
    VendasDatasetrotas_id: TIntegerField;
    VendasDatasetconvenios_id: TIntegerField;
    VendasDatasetdependentes_id: TIntegerField;
    VendasDatasetemissao_terceiros: TBooleanField;
    VendasDatasetchave_acesso_terceiros: TStringField;
    VendasDatasetmensalidade_id: TIntegerField;
    VendasDatasetcodigo_producao: TStringField;
    VendasDatasetsimples_faturamento: TBooleanField;
    VendasDatasetvalor_icms_desonerado: TFloatField;
    VendasDatasetvalor_ipi_devolucao: TFloatField;
    VendasDatasetexcluiu_icms_base_pis_cofins: TBooleanField;
    VendasDatasetvalor_fcp_st: TFloatField;
    VendasDatasetvalor_retido_pis: TFloatField;
    VendasDatasetvalor_retido_cofins: TFloatField;
    VendasDatasetvalor_retido_csll: TFloatField;
    VendasDatasetvalor_base_calculo_irrf: TFloatField;
    VendasDatasetaliquota_irrf: TFloatField;
    VendasDatasetvalor_retido_irrf: TFloatField;
    VendasDatasetvalor_base_calculo_previdencia_social: TFloatField;
    VendasDatasetaliquota_previdencia_social: TFloatField;
    VendasDatasetvalor_previdencia_social: TFloatField;
    VendasDatasetexcluiu_fcp_base_pis_cofins: TBooleanField;
    VendasDatasetcodigo_interno: TIntegerField;
    VendasDatasetexcluido: TBooleanField;
    VendasDatasetinclusao: TDateTimeField;
    VendasDatasetalteracao: TDateTimeField;
    VendasDatasetexclusao: TDateTimeField;
    VendasDatasetfuncionarionome: TStringField;
    VendasDatasetclienterazao_social_nome: TStringField;
    VendasDatasetcfopnome: TStringField;
    cbxexcluido: TDBCheckBox;
    cbxipi_compoe_base_icms: TDBCheckBox;
    cbxfrete_compoe_base_icms: TDBCheckBox;
    cbxseguro_compoe_base_icms: TDBCheckBox;
    cbxoutras_compoe_base_icms: TDBCheckBox;
    cbxexcluiu_icms_base_pis_cofins: TDBCheckBox;
    cbxexcluiu_fcp_base_pis_cofins: TDBCheckBox;
    cbxsimples_faturamento: TDBCheckBox;
    cbxemissao_terceiros: TDBCheckBox;
    pnlFormDados: TPanel;
    tblItens: TDBTableControl;
    cbPageSizeItens: TComboBox;
    edSearchItens: TEdit;
    pnlItensPromocao: TPanel;
    btnItensTab: TButton;
    cdsItens: TXDataWebDataSet;
    dtsItens: TDataSource;
    tmrConsultaItens: TTimer;
    cdsItensproduto_id: TIntegerField;
    cdsItensitem: TIntegerField;
    cdsItensquantidade: TFloatField;
    cdsItensproduto_preco: TFloatField;
    cdsItensvalor_total: TFloatField;
    cdsItensprodnome: TStringField;
    cdsItensprodcodigo_interno: TIntegerField;
    lbPaginationInfoItens: TLabel;
    lcPaginatorItens: TListControl;
    lbPaginationInfoAReceber: TLabel;
    pnlTabelaAReceber: TPanel;
    tblAReceber: TDBTableControl;
    lcPaginatorAReceber: TListControl;
    tblRecebimentos: TDBTableControl;
    pnlTabelaPagamentos: TPanel;
    cdsRecebimentos: TXDataWebDataSet;
    cdsRecebimentosvalor_bruto_recebido: TFloatField;
    cdsRecebimentosdata_recebimento: TDateTimeField;
    cdsRecebimentosmodalidadenome: TStringField;
    cdsRecebimentosareceberdocumento: TStringField;
    cdsRecebimentosareceberparcela: TXDataWebDatasetField;
    dtsRecebimentos: TDataSource;
    dtsAReceber: TDataSource;
    cdsAReceber: TXDataWebDataSet;
    cdsAReceberdocumento: TStringField;
    cdsAReceberparcela: TStringField;
    cdsAReceberemissao: TDateTimeField;
    cdsARecebervencimento: TDateTimeField;
    cdsARecebervalor_total: TFloatField;
    cdsARecebervalor_saldo_pendente: TFloatField;
    cdsARecebervalor_pago: TFloatField;
    btnFinanceiroTab: TButton;
    btnRecebimentosTab: TButton;
    lbPaginationInfoRecebimentos: TLabel;
    lcPaginatorRecebimentos: TListControl;
    cdsItensunidadesigla: TStringField;
    pnlFormNfe: TPanel;
    lbchave_acesso: TLabel;
    edchave_acesso: TDBEdit;
    lbnfe_transmissao: TLabel;
    ednfe_transmissao: TDBEdit;
    btnCopiarChaveAcesso: TButton;
    VendasDatasetnfechave_acesso: TStringField;
    VendasDatasetnfenfe_cancelada: TXDataWebDatasetField;
    VendasDatasetnfenfe_transmissao: TDateTimeField;
    btnNfeTab: TButton;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientVendasGetLoad(Response: TXDataClientResponse);
    procedure VendasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure VendasDatasetcfop_cfopGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure VendasDatasetfrete_por_contaGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure btnItensTabClick(Sender: TObject);
    procedure tblItensGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure tblItensGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure cdsItensitemGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cbPageSizeItensChange(Sender: TObject);
    procedure edSearchItensKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchItensKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaItensTimer(Sender: TObject);
    procedure btnFinanceiroTabClick(Sender: TObject);
    procedure cdsAReceberdocumentoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure tblAReceberGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblAReceberGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure btnRecebimentosTabClick(Sender: TObject);
    procedure cdsRecebimentosareceberdocumentoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure tblRecebimentosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure WebFormShow(Sender: TObject);
    procedure btnCopiarChaveAcessoClick(Sender: TObject);
    procedure btnNfeTabClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginItens,
    FGridPluginAReceber,
    FGridPluginRecebimentos : TGridPlugin;

    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure CarregarAReceber;
    procedure CarregarRecebimentos;
    procedure ConfigurarPermissoes;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewVendasEdit: TFViewVendasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewVendasEdit }

procedure TFViewVendasEdit.btnCopiarChaveAcessoClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Chave de acesso copiada com sucesso!', 'Cópia de chave de acesso',
    edchave_acesso.Text);
end;

procedure TFViewVendasEdit.btnFinanceiroTabClick(Sender: TObject);
begin
  if TUtils.PossuiPermissao(cdsAReceber.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
    CarregarAReceber
  else
  begin
    TUtils.SelecionarTab('#line-recebimentos-tab');
    CarregarRecebimentos;
  end;
end;

procedure TFViewVendasEdit.btnItensTabClick(Sender: TObject);
begin
  if cdsItens.Tag = 0 then
  begin
    cdsItens.Tag := 1;

    FGridPluginItens := TGridPlugin.Create(tblItens, cdsItens, lcPaginatorItens, lbPaginationInfoItens);
    FGridPluginItens.FDatasetPlugin.FFilterPadrao := '(venda_id eq ' + edid.Text +')';
    FGridPluginItens.FDatasetPlugin.FOrderByPadrao := 'item asc';
    FGridPluginItens.SetPageSize(StrToInt(cbPageSizeItens.Text));
    FGridPluginItens.SetFilterText(edSearchItens.Text);
    FGridPluginItens.Load;
  end;
end;

procedure TFViewVendasEdit.btnNfeTabClick(Sender: TObject);
begin
  if edchave_acesso.Text = '' then
    btnCopiarChaveAcesso.Enabled := False;
end;

procedure TFViewVendasEdit.btnRecebimentosTabClick(Sender: TObject);
begin
  CarregarRecebimentos;
end;

procedure TFViewVendasEdit.CarregarAReceber;
begin
  if cdsAReceber.Tag = 0 then
  begin
    cdsAReceber.Tag := 1;

    FGridPluginAReceber := TGridPlugin.Create(tblAReceber, cdsAReceber, lcPaginatorAReceber,
      lbPaginationInfoAReceber);
    FGridPluginAReceber.FDatasetPlugin.FFilterPadrao := '(venda_id eq ' + edid.Text +')';
    FGridPluginAReceber.FDatasetPlugin.FOrderByPadrao := 'vencimento asc';
    FGridPluginAReceber.SetPageSize(10);
    FGridPluginAReceber.SetFilterText(EmptyStr);
    FGridPluginAReceber.Load;
  end;
end;

procedure TFViewVendasEdit.CarregarRecebimentos;
begin
  if cdsRecebimentos.Tag = 0 then
  begin
    cdsRecebimentos.Tag := 1;

    FGridPluginRecebimentos := TGridPlugin.Create(tblRecebimentos, cdsRecebimentos, lcPaginatorRecebimentos,
      lbPaginationInfoRecebimentos);
    FGridPluginRecebimentos.FDatasetPlugin.FFilterPadrao := '(areceber/venda_id eq ' + edid.Text +')';
    FGridPluginRecebimentos.FDatasetPlugin.FOrderByPadrao := 'data_recebimento desc, codigo_interno desc';
    FGridPluginRecebimentos.SetPageSize(10);
    FGridPluginRecebimentos.SetFilterText(EmptyStr);
    FGridPluginRecebimentos.Load;
  end;
end;

procedure TFViewVendasEdit.cbPageSizeItensChange(Sender: TObject);
begin
  FGridPluginItens.SetPageSize(StrToInt(cbPageSizeItens.Text), True);
end;

procedure TFViewVendasEdit.cdsAReceberdocumentoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarDocumento(Sender.AsString, cdsAReceber.FieldByName('parcela').AsInteger);
end;

procedure TFViewVendasEdit.cdsItensitemGetText(Sender: TField; var Text: string;
  DisplayText: Boolean);
begin
  Text := Format('%.3d', [Sender.AsInteger]);
end;

procedure TFViewVendasEdit.cdsRecebimentosareceberdocumentoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarDocumento(Sender.AsString, cdsRecebimentos.FieldByName('areceber.parcela').AsInteger);
end;

procedure TFViewVendasEdit.ConfigurarPermissoes;
begin
  if not TUtils.PossuiPermissao(cdsItens.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-itens-tab');
    TUtils.RemoverElementoPorId('line-itens');
  end;

  if not TUtils.PossuiPermissao(cdsAReceber.EntitySetName.ToLower, TTipoPermissao.Visualizar) and
    not TUtils.PossuiPermissao(cdsRecebimentos.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-financeiro-tab');
    TUtils.RemoverElementoPorId('line-financeiro');
  end
  else if not TUtils.PossuiPermissao(cdsAReceber.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-areceber-tab');
    TUtils.RemoverElementoPorId('line-areceber');
  end
  else if not TUtils.PossuiPermissao(cdsRecebimentos.EntitySetName.ToLower, TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-recebimentos-tab');
    TUtils.RemoverElementoPorId('line-recebimentos');
  end;

  if not TUtils.PossuiPermissao('nfe', TTipoPermissao.Visualizar) then
  begin
    TUtils.RemoverElementoPorId('line-nfe-tab');
    TUtils.RemoverElementoPorId('line-nfe');
  end;
end;

class function TFViewVendasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewVendasEdit.edSearchItensKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaItens.Enabled := False;

  if Key = 13 then
    FGridPluginItens.SetFilterText(edSearchItens.Text, True);
end;

procedure TFViewVendasEdit.edSearchItensKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaItens.Interval := FTimerConsulta;
  tmrConsultaItens.Enabled := True;
end;

procedure TFViewVendasEdit.InsertEntity;
begin
  VendasDataset.Close;
  VendasDataset.SetJsonData('{}');
  VendasDataset.Open;
  VendasDataset.Insert;
end;

class function TFViewVendasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewVendasEdit(AForm).FInserting := AInserting;
    TFViewVendasEdit(AForm).FId := AId;
    TFViewVendasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewVendasEdit(AForm).InsertEntity
    else
      TFViewVendasEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewVendasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewVendasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    VendasDataset.Connection.Model.DefaultSchema.FindEntityType(
      VendasDataset.EntitySetName
    )
  );
  XDataClientVendasGet.Get(VendasDataset.EntitySetName, QueryString + ',cliente, funcionario, cfop', FId);
end;


procedure TFViewVendasEdit.tblAReceberGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblAReceber.Columns[ACol].DataField, ['valor_total', 'valor_saldo_pendente',
      'valor_pago', 'documento']) of
      0, 1, 2: AClassName := 'text-end';
      3: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewVendasEdit.tblAReceberGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
var
  lTituloVencido : Boolean;
begin
  if ARow > 0 then
  begin
    lTituloVencido := (tblAReceber.DataSource.DataSet.FieldByName('valor_saldo_pendente').AsFloat > 0) and
      (StrToDate(tblAReceber.DataSource.DataSet.FieldByName('vencimento').AsString) < Date);

    if lTituloVencido then
      AValue := '<p class="text-danger">' + AValue + '</p>'
  end;
end;

procedure TFViewVendasEdit.tblItensGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);

  procedure EditButtonClick(Sender: TObject);
  begin
    //FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblItens.Columns[ACol].Title = 'Ação' then
  begin
    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_item');
  end;
end;

procedure TFViewVendasEdit.tblItensGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblItens.Columns[ACol].DataField, ['prod.nome', 'quantidade',
     'produto_preco', 'valor_total']) of
      0: AClassName := 'text-start';
      1, 2, 3: AClassName := 'text-end'
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewVendasEdit.tblRecebimentosGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if cdsRecebimentos.Tag = 0 then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblRecebimentos.Columns[ACol].DataField, ['valor_bruto_recebido', 'modalidade.nome',
      'areceber.documento']) of
      0: AClassName := 'text-end';
      1, 2: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewVendasEdit.tmrConsultaItensTimer(Sender: TObject);
begin
  FGridPluginItens.SetFilterText(edSearchItens.Text, True);

  tmrConsultaItens.Enabled := False;
  tmrConsultaItens.Interval := FTimerConsulta;
end;

procedure TFViewVendasEdit.XDataClientVendasGetLoad(Response: TXDataClientResponse);
begin
  VendasDataset.Close;
  VendasDataset.SetJsonData(Response.Result);
  VendasDataset.Open;
  
  VendasDataset.Edit;  
end;

procedure TFViewVendasEdit.VendasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin

      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewVendasEdit.VendasDatasetcfop_cfopGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Exit;

  Text := Sender.AsString + ' - ' + VendasDataset.FieldByName('cfop.nome').AsString;
end;

procedure TFViewVendasEdit.VendasDatasetfrete_por_contaGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.IsEmpty then
    Exit;

  if Sender.AsInteger = 0 then
    Text := 'Emitente'
  else
    Text := 'Destinatário';
end;

procedure TFViewVendasEdit.WebFormShow(Sender: TObject);
begin
  ConfigurarPermissoes;
end;

procedure TFViewVendasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewVendasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.vendas.form.lbid');
  lbcliente_id := TLabel.Create('view.vendas.form.lbcliente_id');
  lbfuncionario_id := TLabel.Create('view.vendas.form.lbfuncionario_id');
  lbcaixa := TLabel.Create('view.vendas.form.lbcaixa');
  lbcfop_cfop := TLabel.Create('view.vendas.form.lbcfop_cfop');
  lbnumero := TLabel.Create('view.vendas.form.lbnumero');
  lbdoc_auxiliar := TLabel.Create('view.vendas.form.lbdoc_auxiliar');
  lbmodelo := TLabel.Create('view.vendas.form.lbmodelo');
  lbserie := TLabel.Create('view.vendas.form.lbserie');
  lbsubserie := TLabel.Create('view.vendas.form.lbsubserie');
  lbdata_emissao := TLabel.Create('view.vendas.form.lbdata_emissao');
  lbdata_saida := TLabel.Create('view.vendas.form.lbdata_saida');
  lbvalor_acrescimos := TLabel.Create('view.vendas.form.lbvalor_acrescimos');
  lbvalor_descontos := TLabel.Create('view.vendas.form.lbvalor_descontos');
  lbvalor_base_calculo_icms := TLabel.Create('view.vendas.form.lbvalor_base_calculo_icms');
  lbvalor_icms := TLabel.Create('view.vendas.form.lbvalor_icms');
  lbvalor_base_calculo_st := TLabel.Create('view.vendas.form.lbvalor_base_calculo_st');
  lbvalor_st := TLabel.Create('view.vendas.form.lbvalor_st');
  lbvalor_seguro := TLabel.Create('view.vendas.form.lbvalor_seguro');
  lbvalor_frete := TLabel.Create('view.vendas.form.lbvalor_frete');
  lbvalor_ipi := TLabel.Create('view.vendas.form.lbvalor_ipi');
  lbvalor_outras := TLabel.Create('view.vendas.form.lbvalor_outras');
  lbvalor_total_itens := TLabel.Create('view.vendas.form.lbvalor_total_itens');
  lbvalor_total := TLabel.Create('view.vendas.form.lbvalor_total');
  lbvolumes_quantidade := TLabel.Create('view.vendas.form.lbvolumes_quantidade');
  lbvolumes_especie := TLabel.Create('view.vendas.form.lbvolumes_especie');
  lbvolumes_marca := TLabel.Create('view.vendas.form.lbvolumes_marca');
  lbvolumes_peso_bruto := TLabel.Create('view.vendas.form.lbvolumes_peso_bruto');
  lbvolumes_peso_liquido := TLabel.Create('view.vendas.form.lbvolumes_peso_liquido');
  lbfrete_por_conta := TLabel.Create('view.vendas.form.lbfrete_por_conta');
  lbobservacoes_credito := TLabel.Create('view.vendas.form.lbobservacoes_credito');
  lbobservacoes := TLabel.Create('view.vendas.form.lbobservacoes');
  lbnota_situacao := TLabel.Create('view.vendas.form.lbnota_situacao');
  lbipi_compoe_base_icms := TLabel.Create('view.vendas.form.lbipi_compoe_base_icms');
  lbfrete_compoe_base_icms := TLabel.Create('view.vendas.form.lbfrete_compoe_base_icms');
  lbseguro_compoe_base_icms := TLabel.Create('view.vendas.form.lbseguro_compoe_base_icms');
  lboutras_compoe_base_icms := TLabel.Create('view.vendas.form.lboutras_compoe_base_icms');
  lbvalor_isentas := TLabel.Create('view.vendas.form.lbvalor_isentas');
  lbdata_entrega := TLabel.Create('view.vendas.form.lbdata_entrega');
  lbdata_movimento := TLabel.Create('view.vendas.form.lbdata_movimento');
  lbemissao_terceiros := TLabel.Create('view.vendas.form.lbemissao_terceiros');
  lbchave_acesso_terceiros := TLabel.Create('view.vendas.form.lbchave_acesso_terceiros');
  lbsimples_faturamento := TLabel.Create('view.vendas.form.lbsimples_faturamento');
  lbvalor_icms_desonerado := TLabel.Create('view.vendas.form.lbvalor_icms_desonerado');
  lbvalor_ipi_devolucao := TLabel.Create('view.vendas.form.lbvalor_ipi_devolucao');
  lbexcluiu_icms_base_pis_cofins := TLabel.Create('view.vendas.form.lbexcluiu_icms_base_pis_cofins');
  lbvalor_fcp_st := TLabel.Create('view.vendas.form.lbvalor_fcp_st');
  lbvalor_retido_pis := TLabel.Create('view.vendas.form.lbvalor_retido_pis');
  lbvalor_retido_cofins := TLabel.Create('view.vendas.form.lbvalor_retido_cofins');
  lbvalor_retido_csll := TLabel.Create('view.vendas.form.lbvalor_retido_csll');
  lbvalor_base_calculo_irrf := TLabel.Create('view.vendas.form.lbvalor_base_calculo_irrf');
  lbaliquota_irrf := TLabel.Create('view.vendas.form.lbaliquota_irrf');
  lbvalor_retido_irrf := TLabel.Create('view.vendas.form.lbvalor_retido_irrf');
  lbvalor_base_calculo_previdencia_social := TLabel.Create('view.vendas.form.lbvalor_base_calculo_previdencia_social');
  lbaliquota_previdencia_social := TLabel.Create('view.vendas.form.lbaliquota_previdencia_social');
  lbvalor_previdencia_social := TLabel.Create('view.vendas.form.lbvalor_previdencia_social');
  lbexcluiu_fcp_base_pis_cofins := TLabel.Create('view.vendas.form.lbexcluiu_fcp_base_pis_cofins');
  lbcodigo_interno := TLabel.Create('view.vendas.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.vendas.form.lbexcluido');
  lbinclusao := TLabel.Create('view.vendas.form.lbinclusao');
  lbalteracao := TLabel.Create('view.vendas.form.lbalteracao');
  lbexclusao := TLabel.Create('view.vendas.form.lbexclusao');
  lbPaginationInfoItens := TLabel.Create('lbPaginationInfoItens');
  lbPaginationInfoAReceber := TLabel.Create('lbPaginationInfoAReceber');
  lbPaginationInfoRecebimentos := TLabel.Create('lbPaginationInfoRecebimentos');
  lbchave_acesso := TLabel.Create('view.vendas.form.lbchave_acesso');
  lbnfe_transmissao := TLabel.Create('view.vendas.form.lbnfe_transmissao');
  btCancel := TButton.Create('view.vendas.form.btBack');
  edid := TDBEdit.Create('view.vendas.form.edid');
  edcliente_id := TDBEdit.Create('view.vendas.form.edcliente_id');
  edfuncionario_id := TDBEdit.Create('view.vendas.form.edfuncionario_id');
  edcaixa := TDBEdit.Create('view.vendas.form.edcaixa');
  edcfop_cfop := TDBEdit.Create('view.vendas.form.edcfop_cfop');
  ednumero := TDBEdit.Create('view.vendas.form.ednumero');
  eddoc_auxiliar := TDBEdit.Create('view.vendas.form.eddoc_auxiliar');
  edmodelo := TDBEdit.Create('view.vendas.form.edmodelo');
  edserie := TDBEdit.Create('view.vendas.form.edserie');
  edsubserie := TDBEdit.Create('view.vendas.form.edsubserie');
  eddata_emissao := TDBEdit.Create('view.vendas.form.eddata_emissao');
  eddata_saida := TDBEdit.Create('view.vendas.form.eddata_saida');
  edvalor_acrescimos := TDBEdit.Create('view.vendas.form.edvalor_acrescimos');
  edvalor_descontos := TDBEdit.Create('view.vendas.form.edvalor_descontos');
  edvalor_base_calculo_icms := TDBEdit.Create('view.vendas.form.edvalor_base_calculo_icms');
  edvalor_icms := TDBEdit.Create('view.vendas.form.edvalor_icms');
  edvalor_base_calculo_st := TDBEdit.Create('view.vendas.form.edvalor_base_calculo_st');
  edvalor_st := TDBEdit.Create('view.vendas.form.edvalor_st');
  edvalor_seguro := TDBEdit.Create('view.vendas.form.edvalor_seguro');
  edvalor_frete := TDBEdit.Create('view.vendas.form.edvalor_frete');
  edvalor_ipi := TDBEdit.Create('view.vendas.form.edvalor_ipi');
  edvalor_outras := TDBEdit.Create('view.vendas.form.edvalor_outras');
  edvalor_total_itens := TDBEdit.Create('view.vendas.form.edvalor_total_itens');
  edvalor_total := TDBEdit.Create('view.vendas.form.edvalor_total');
  edvolumes_quantidade := TDBEdit.Create('view.vendas.form.edvolumes_quantidade');
  edvolumes_especie := TDBEdit.Create('view.vendas.form.edvolumes_especie');
  edvolumes_marca := TDBEdit.Create('view.vendas.form.edvolumes_marca');
  edvolumes_peso_bruto := TDBEdit.Create('view.vendas.form.edvolumes_peso_bruto');
  edvolumes_peso_liquido := TDBEdit.Create('view.vendas.form.edvolumes_peso_liquido');
  edfrete_por_conta := TDBEdit.Create('view.vendas.form.edfrete_por_conta');
  edobservacoes_credito := TDBEdit.Create('view.vendas.form.edobservacoes_credito');
  edobservacoes := TDBEdit.Create('view.vendas.form.edobservacoes');
  ednota_situacao := TDBEdit.Create('view.vendas.form.ednota_situacao');
  edvalor_isentas := TDBEdit.Create('view.vendas.form.edvalor_isentas');
  eddata_entrega := TDBEdit.Create('view.vendas.form.eddata_entrega');
  eddata_movimento := TDBEdit.Create('view.vendas.form.eddata_movimento');
  edchave_acesso_terceiros := TDBEdit.Create('view.vendas.form.edchave_acesso_terceiros');
  edvalor_icms_desonerado := TDBEdit.Create('view.vendas.form.edvalor_icms_desonerado');
  edvalor_ipi_devolucao := TDBEdit.Create('view.vendas.form.edvalor_ipi_devolucao');
  edvalor_fcp_st := TDBEdit.Create('view.vendas.form.edvalor_fcp_st');
  edvalor_retido_pis := TDBEdit.Create('view.vendas.form.edvalor_retido_pis');
  edvalor_retido_cofins := TDBEdit.Create('view.vendas.form.edvalor_retido_cofins');
  edvalor_retido_csll := TDBEdit.Create('view.vendas.form.edvalor_retido_csll');
  edvalor_base_calculo_irrf := TDBEdit.Create('view.vendas.form.edvalor_base_calculo_irrf');
  edaliquota_irrf := TDBEdit.Create('view.vendas.form.edaliquota_irrf');
  edvalor_retido_irrf := TDBEdit.Create('view.vendas.form.edvalor_retido_irrf');
  edvalor_base_calculo_previdencia_social := TDBEdit.Create('view.vendas.form.edvalor_base_calculo_previdencia_social');
  edaliquota_previdencia_social := TDBEdit.Create('view.vendas.form.edaliquota_previdencia_social');
  edvalor_previdencia_social := TDBEdit.Create('view.vendas.form.edvalor_previdencia_social');
  edcodigo_interno := TDBEdit.Create('view.vendas.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.vendas.form.edinclusao');
  edalteracao := TDBEdit.Create('view.vendas.form.edalteracao');
  edexclusao := TDBEdit.Create('view.vendas.form.edexclusao');
  cbxexcluido := TDBCheckBox.Create('view.vendas.form.cbxexcluido');
  cbxipi_compoe_base_icms := TDBCheckBox.Create('view.vendas.form.cbxipi_compoe_base_icms');
  cbxfrete_compoe_base_icms := TDBCheckBox.Create('view.vendas.form.cbxfrete_compoe_base_icms');
  cbxseguro_compoe_base_icms := TDBCheckBox.Create('view.vendas.form.cbxseguro_compoe_base_icms');
  cbxoutras_compoe_base_icms := TDBCheckBox.Create('view.vendas.form.cbxoutras_compoe_base_icms');
  cbxexcluiu_icms_base_pis_cofins := TDBCheckBox.Create('view.vendas.form.cbxexcluiu_icms_base_pis_cofins');
  cbxexcluiu_fcp_base_pis_cofins := TDBCheckBox.Create('view.vendas.form.cbxexcluiu_fcp_base_pis_cofins');
  cbxsimples_faturamento := TDBCheckBox.Create('view.vendas.form.cbxsimples_faturamento');
  cbxemissao_terceiros := TDBCheckBox.Create('view.vendas.form.cbxemissao_terceiros');
  pnlFormDados := TPanel.Create(Self);
  tblItens := TDBTableControl.Create('tblItens');
  cbPageSizeItens := TComboBox.Create('cbPageSizeItens');
  edSearchItens := TEdit.Create('edSearchItens');
  pnlItensPromocao := TPanel.Create(Self);
  btnItensTab := TButton.Create('line-itens-tab');
  lcPaginatorItens := TListControl.Create('lcPaginatorItens');
  pnlTabelaAReceber := TPanel.Create(Self);
  tblAReceber := TDBTableControl.Create('tblAReceber');
  lcPaginatorAReceber := TListControl.Create('lcPaginatorAReceber');
  tblRecebimentos := TDBTableControl.Create('tblRecebimentos');
  pnlTabelaPagamentos := TPanel.Create(Self);
  btnFinanceiroTab := TButton.Create('line-financeiro-tab');
  btnRecebimentosTab := TButton.Create('line-recebimentos-tab');
  lcPaginatorRecebimentos := TListControl.Create('lcPaginatorRecebimentos');
  pnlFormNfe := TPanel.Create(Self);
  edchave_acesso := TDBEdit.Create('view.vendas.form.edchave_acesso');
  ednfe_transmissao := TDBEdit.Create('view.vendas.form.ednfe_transmissao');
  btnCopiarChaveAcesso := TButton.Create('btnCopiarChaveAcesso');
  btnNfeTab := TButton.Create('line-nfe-tab');
  DataSource := TDataSource.Create(Self);
  VendasDataset := TXDataWebDataSet.Create(Self);
  VendasDatasetid := TIntegerField.Create(Self);
  VendasDatasetaliado_id := TIntegerField.Create(Self);
  VendasDatasetdata_base_id := TIntegerField.Create(Self);
  VendasDatasetcliente_id := TIntegerField.Create(Self);
  VendasDatasetfuncionario_id := TIntegerField.Create(Self);
  VendasDatasetcaixa := TIntegerField.Create(Self);
  VendasDatasetcfop_cfop := TStringField.Create(Self);
  VendasDatasetnumero := TStringField.Create(Self);
  VendasDatasetdoc_auxiliar := TStringField.Create(Self);
  VendasDatasetmodelo := TStringField.Create(Self);
  VendasDatasetserie := TStringField.Create(Self);
  VendasDatasetsubserie := TStringField.Create(Self);
  VendasDatasetdata_emissao := TDateTimeField.Create(Self);
  VendasDatasetdata_saida := TDateTimeField.Create(Self);
  VendasDatasetvalor_acrescimos := TFloatField.Create(Self);
  VendasDatasetvalor_descontos := TFloatField.Create(Self);
  VendasDatasetvalor_base_calculo_icms := TFloatField.Create(Self);
  VendasDatasetvalor_icms := TFloatField.Create(Self);
  VendasDatasetvalor_base_calculo_st := TFloatField.Create(Self);
  VendasDatasetvalor_st := TFloatField.Create(Self);
  VendasDatasetvalor_seguro := TFloatField.Create(Self);
  VendasDatasetvalor_frete := TFloatField.Create(Self);
  VendasDatasetvalor_ipi := TFloatField.Create(Self);
  VendasDatasetvalor_outras := TFloatField.Create(Self);
  VendasDatasetvalor_total_itens := TFloatField.Create(Self);
  VendasDatasetvalor_total := TFloatField.Create(Self);
  VendasDatasettransportadora_id := TIntegerField.Create(Self);
  VendasDatasetplaca_veiculo := TStringField.Create(Self);
  VendasDatasetvolumes_quantidade := TIntegerField.Create(Self);
  VendasDatasetvolumes_especie := TStringField.Create(Self);
  VendasDatasetvolumes_marca := TStringField.Create(Self);
  VendasDatasetvolumes_peso_bruto := TFloatField.Create(Self);
  VendasDatasetvolumes_peso_liquido := TFloatField.Create(Self);
  VendasDatasetfrete_por_conta := TIntegerField.Create(Self);
  VendasDatasetobservacoes_credito := TStringField.Create(Self);
  VendasDatasetobservacoes := TStringField.Create(Self);
  VendasDatasetnota_situacao := TIntegerField.Create(Self);
  VendasDatasetipi_compoe_base_icms := TBooleanField.Create(Self);
  VendasDatasetfrete_compoe_base_icms := TBooleanField.Create(Self);
  VendasDatasetseguro_compoe_base_icms := TBooleanField.Create(Self);
  VendasDatasetoutras_compoe_base_icms := TBooleanField.Create(Self);
  VendasDatasetvalor_isentas := TFloatField.Create(Self);
  VendasDatasetcliente_fidelidade_id := TIntegerField.Create(Self);
  VendasDatasetnfe_id := TIntegerField.Create(Self);
  VendasDatasetnfse_id := TIntegerField.Create(Self);
  VendasDatasetosv_oss_id := TIntegerField.Create(Self);
  VendasDatasetose_oss_id := TIntegerField.Create(Self);
  VendasDatasetorcamentos_id := TIntegerField.Create(Self);
  VendasDatasetpet_vendas_id := TIntegerField.Create(Self);
  VendasDatasetpet_prontuarios_id := TIntegerField.Create(Self);
  VendasDatasetdata_entrega := TDateTimeField.Create(Self);
  VendasDatasetdata_movimento := TDateTimeField.Create(Self);
  VendasDatasetnome_consumidor_final := TStringField.Create(Self);
  VendasDatasetrotas_id := TIntegerField.Create(Self);
  VendasDatasetconvenios_id := TIntegerField.Create(Self);
  VendasDatasetdependentes_id := TIntegerField.Create(Self);
  VendasDatasetemissao_terceiros := TBooleanField.Create(Self);
  VendasDatasetchave_acesso_terceiros := TStringField.Create(Self);
  VendasDatasetmensalidade_id := TIntegerField.Create(Self);
  VendasDatasetcodigo_producao := TStringField.Create(Self);
  VendasDatasetsimples_faturamento := TBooleanField.Create(Self);
  VendasDatasetvalor_icms_desonerado := TFloatField.Create(Self);
  VendasDatasetvalor_ipi_devolucao := TFloatField.Create(Self);
  VendasDatasetexcluiu_icms_base_pis_cofins := TBooleanField.Create(Self);
  VendasDatasetvalor_fcp_st := TFloatField.Create(Self);
  VendasDatasetvalor_retido_pis := TFloatField.Create(Self);
  VendasDatasetvalor_retido_cofins := TFloatField.Create(Self);
  VendasDatasetvalor_retido_csll := TFloatField.Create(Self);
  VendasDatasetvalor_base_calculo_irrf := TFloatField.Create(Self);
  VendasDatasetaliquota_irrf := TFloatField.Create(Self);
  VendasDatasetvalor_retido_irrf := TFloatField.Create(Self);
  VendasDatasetvalor_base_calculo_previdencia_social := TFloatField.Create(Self);
  VendasDatasetaliquota_previdencia_social := TFloatField.Create(Self);
  VendasDatasetvalor_previdencia_social := TFloatField.Create(Self);
  VendasDatasetexcluiu_fcp_base_pis_cofins := TBooleanField.Create(Self);
  VendasDatasetcodigo_interno := TIntegerField.Create(Self);
  VendasDatasetexcluido := TBooleanField.Create(Self);
  VendasDatasetinclusao := TDateTimeField.Create(Self);
  VendasDatasetalteracao := TDateTimeField.Create(Self);
  VendasDatasetexclusao := TDateTimeField.Create(Self);
  VendasDatasetfuncionarionome := TStringField.Create(Self);
  VendasDatasetclienterazao_social_nome := TStringField.Create(Self);
  VendasDatasetcfopnome := TStringField.Create(Self);
  VendasDatasetnfechave_acesso := TStringField.Create(Self);
  VendasDatasetnfenfe_cancelada := TXDataWebDatasetField.Create(Self);
  VendasDatasetnfenfe_transmissao := TDateTimeField.Create(Self);
  XDataClientVendasGet := TXDataWebClient.Create(Self);
  cdsItens := TXDataWebDataSet.Create(Self);
  cdsItensproduto_id := TIntegerField.Create(Self);
  cdsItensitem := TIntegerField.Create(Self);
  cdsItensquantidade := TFloatField.Create(Self);
  cdsItensproduto_preco := TFloatField.Create(Self);
  cdsItensvalor_total := TFloatField.Create(Self);
  cdsItensprodnome := TStringField.Create(Self);
  cdsItensprodcodigo_interno := TIntegerField.Create(Self);
  cdsItensunidadesigla := TStringField.Create(Self);
  dtsItens := TDataSource.Create(Self);
  tmrConsultaItens := TTimer.Create(Self);
  cdsRecebimentos := TXDataWebDataSet.Create(Self);
  cdsRecebimentosvalor_bruto_recebido := TFloatField.Create(Self);
  cdsRecebimentosdata_recebimento := TDateTimeField.Create(Self);
  cdsRecebimentosmodalidadenome := TStringField.Create(Self);
  cdsRecebimentosareceberdocumento := TStringField.Create(Self);
  cdsRecebimentosareceberparcela := TXDataWebDatasetField.Create(Self);
  dtsRecebimentos := TDataSource.Create(Self);
  dtsAReceber := TDataSource.Create(Self);
  cdsAReceber := TXDataWebDataSet.Create(Self);
  cdsAReceberdocumento := TStringField.Create(Self);
  cdsAReceberparcela := TStringField.Create(Self);
  cdsAReceberemissao := TDateTimeField.Create(Self);
  cdsARecebervencimento := TDateTimeField.Create(Self);
  cdsARecebervalor_total := TFloatField.Create(Self);
  cdsARecebervalor_saldo_pendente := TFloatField.Create(Self);
  cdsARecebervalor_pago := TFloatField.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbcliente_id.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  lbcaixa.BeforeLoadDFMValues;
  lbcfop_cfop.BeforeLoadDFMValues;
  lbnumero.BeforeLoadDFMValues;
  lbdoc_auxiliar.BeforeLoadDFMValues;
  lbmodelo.BeforeLoadDFMValues;
  lbserie.BeforeLoadDFMValues;
  lbsubserie.BeforeLoadDFMValues;
  lbdata_emissao.BeforeLoadDFMValues;
  lbdata_saida.BeforeLoadDFMValues;
  lbvalor_acrescimos.BeforeLoadDFMValues;
  lbvalor_descontos.BeforeLoadDFMValues;
  lbvalor_base_calculo_icms.BeforeLoadDFMValues;
  lbvalor_icms.BeforeLoadDFMValues;
  lbvalor_base_calculo_st.BeforeLoadDFMValues;
  lbvalor_st.BeforeLoadDFMValues;
  lbvalor_seguro.BeforeLoadDFMValues;
  lbvalor_frete.BeforeLoadDFMValues;
  lbvalor_ipi.BeforeLoadDFMValues;
  lbvalor_outras.BeforeLoadDFMValues;
  lbvalor_total_itens.BeforeLoadDFMValues;
  lbvalor_total.BeforeLoadDFMValues;
  lbvolumes_quantidade.BeforeLoadDFMValues;
  lbvolumes_especie.BeforeLoadDFMValues;
  lbvolumes_marca.BeforeLoadDFMValues;
  lbvolumes_peso_bruto.BeforeLoadDFMValues;
  lbvolumes_peso_liquido.BeforeLoadDFMValues;
  lbfrete_por_conta.BeforeLoadDFMValues;
  lbobservacoes_credito.BeforeLoadDFMValues;
  lbobservacoes.BeforeLoadDFMValues;
  lbnota_situacao.BeforeLoadDFMValues;
  lbipi_compoe_base_icms.BeforeLoadDFMValues;
  lbfrete_compoe_base_icms.BeforeLoadDFMValues;
  lbseguro_compoe_base_icms.BeforeLoadDFMValues;
  lboutras_compoe_base_icms.BeforeLoadDFMValues;
  lbvalor_isentas.BeforeLoadDFMValues;
  lbdata_entrega.BeforeLoadDFMValues;
  lbdata_movimento.BeforeLoadDFMValues;
  lbemissao_terceiros.BeforeLoadDFMValues;
  lbchave_acesso_terceiros.BeforeLoadDFMValues;
  lbsimples_faturamento.BeforeLoadDFMValues;
  lbvalor_icms_desonerado.BeforeLoadDFMValues;
  lbvalor_ipi_devolucao.BeforeLoadDFMValues;
  lbexcluiu_icms_base_pis_cofins.BeforeLoadDFMValues;
  lbvalor_fcp_st.BeforeLoadDFMValues;
  lbvalor_retido_pis.BeforeLoadDFMValues;
  lbvalor_retido_cofins.BeforeLoadDFMValues;
  lbvalor_retido_csll.BeforeLoadDFMValues;
  lbvalor_base_calculo_irrf.BeforeLoadDFMValues;
  lbaliquota_irrf.BeforeLoadDFMValues;
  lbvalor_retido_irrf.BeforeLoadDFMValues;
  lbvalor_base_calculo_previdencia_social.BeforeLoadDFMValues;
  lbaliquota_previdencia_social.BeforeLoadDFMValues;
  lbvalor_previdencia_social.BeforeLoadDFMValues;
  lbexcluiu_fcp_base_pis_cofins.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbPaginationInfoItens.BeforeLoadDFMValues;
  lbPaginationInfoAReceber.BeforeLoadDFMValues;
  lbPaginationInfoRecebimentos.BeforeLoadDFMValues;
  lbchave_acesso.BeforeLoadDFMValues;
  lbnfe_transmissao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edcliente_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  edcaixa.BeforeLoadDFMValues;
  edcfop_cfop.BeforeLoadDFMValues;
  ednumero.BeforeLoadDFMValues;
  eddoc_auxiliar.BeforeLoadDFMValues;
  edmodelo.BeforeLoadDFMValues;
  edserie.BeforeLoadDFMValues;
  edsubserie.BeforeLoadDFMValues;
  eddata_emissao.BeforeLoadDFMValues;
  eddata_saida.BeforeLoadDFMValues;
  edvalor_acrescimos.BeforeLoadDFMValues;
  edvalor_descontos.BeforeLoadDFMValues;
  edvalor_base_calculo_icms.BeforeLoadDFMValues;
  edvalor_icms.BeforeLoadDFMValues;
  edvalor_base_calculo_st.BeforeLoadDFMValues;
  edvalor_st.BeforeLoadDFMValues;
  edvalor_seguro.BeforeLoadDFMValues;
  edvalor_frete.BeforeLoadDFMValues;
  edvalor_ipi.BeforeLoadDFMValues;
  edvalor_outras.BeforeLoadDFMValues;
  edvalor_total_itens.BeforeLoadDFMValues;
  edvalor_total.BeforeLoadDFMValues;
  edvolumes_quantidade.BeforeLoadDFMValues;
  edvolumes_especie.BeforeLoadDFMValues;
  edvolumes_marca.BeforeLoadDFMValues;
  edvolumes_peso_bruto.BeforeLoadDFMValues;
  edvolumes_peso_liquido.BeforeLoadDFMValues;
  edfrete_por_conta.BeforeLoadDFMValues;
  edobservacoes_credito.BeforeLoadDFMValues;
  edobservacoes.BeforeLoadDFMValues;
  ednota_situacao.BeforeLoadDFMValues;
  edvalor_isentas.BeforeLoadDFMValues;
  eddata_entrega.BeforeLoadDFMValues;
  eddata_movimento.BeforeLoadDFMValues;
  edchave_acesso_terceiros.BeforeLoadDFMValues;
  edvalor_icms_desonerado.BeforeLoadDFMValues;
  edvalor_ipi_devolucao.BeforeLoadDFMValues;
  edvalor_fcp_st.BeforeLoadDFMValues;
  edvalor_retido_pis.BeforeLoadDFMValues;
  edvalor_retido_cofins.BeforeLoadDFMValues;
  edvalor_retido_csll.BeforeLoadDFMValues;
  edvalor_base_calculo_irrf.BeforeLoadDFMValues;
  edaliquota_irrf.BeforeLoadDFMValues;
  edvalor_retido_irrf.BeforeLoadDFMValues;
  edvalor_base_calculo_previdencia_social.BeforeLoadDFMValues;
  edaliquota_previdencia_social.BeforeLoadDFMValues;
  edvalor_previdencia_social.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxipi_compoe_base_icms.BeforeLoadDFMValues;
  cbxfrete_compoe_base_icms.BeforeLoadDFMValues;
  cbxseguro_compoe_base_icms.BeforeLoadDFMValues;
  cbxoutras_compoe_base_icms.BeforeLoadDFMValues;
  cbxexcluiu_icms_base_pis_cofins.BeforeLoadDFMValues;
  cbxexcluiu_fcp_base_pis_cofins.BeforeLoadDFMValues;
  cbxsimples_faturamento.BeforeLoadDFMValues;
  cbxemissao_terceiros.BeforeLoadDFMValues;
  pnlFormDados.BeforeLoadDFMValues;
  tblItens.BeforeLoadDFMValues;
  cbPageSizeItens.BeforeLoadDFMValues;
  edSearchItens.BeforeLoadDFMValues;
  pnlItensPromocao.BeforeLoadDFMValues;
  btnItensTab.BeforeLoadDFMValues;
  lcPaginatorItens.BeforeLoadDFMValues;
  pnlTabelaAReceber.BeforeLoadDFMValues;
  tblAReceber.BeforeLoadDFMValues;
  lcPaginatorAReceber.BeforeLoadDFMValues;
  tblRecebimentos.BeforeLoadDFMValues;
  pnlTabelaPagamentos.BeforeLoadDFMValues;
  btnFinanceiroTab.BeforeLoadDFMValues;
  btnRecebimentosTab.BeforeLoadDFMValues;
  lcPaginatorRecebimentos.BeforeLoadDFMValues;
  pnlFormNfe.BeforeLoadDFMValues;
  edchave_acesso.BeforeLoadDFMValues;
  ednfe_transmissao.BeforeLoadDFMValues;
  btnCopiarChaveAcesso.BeforeLoadDFMValues;
  btnNfeTab.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  VendasDataset.BeforeLoadDFMValues;
  VendasDatasetid.BeforeLoadDFMValues;
  VendasDatasetaliado_id.BeforeLoadDFMValues;
  VendasDatasetdata_base_id.BeforeLoadDFMValues;
  VendasDatasetcliente_id.BeforeLoadDFMValues;
  VendasDatasetfuncionario_id.BeforeLoadDFMValues;
  VendasDatasetcaixa.BeforeLoadDFMValues;
  VendasDatasetcfop_cfop.BeforeLoadDFMValues;
  VendasDatasetnumero.BeforeLoadDFMValues;
  VendasDatasetdoc_auxiliar.BeforeLoadDFMValues;
  VendasDatasetmodelo.BeforeLoadDFMValues;
  VendasDatasetserie.BeforeLoadDFMValues;
  VendasDatasetsubserie.BeforeLoadDFMValues;
  VendasDatasetdata_emissao.BeforeLoadDFMValues;
  VendasDatasetdata_saida.BeforeLoadDFMValues;
  VendasDatasetvalor_acrescimos.BeforeLoadDFMValues;
  VendasDatasetvalor_descontos.BeforeLoadDFMValues;
  VendasDatasetvalor_base_calculo_icms.BeforeLoadDFMValues;
  VendasDatasetvalor_icms.BeforeLoadDFMValues;
  VendasDatasetvalor_base_calculo_st.BeforeLoadDFMValues;
  VendasDatasetvalor_st.BeforeLoadDFMValues;
  VendasDatasetvalor_seguro.BeforeLoadDFMValues;
  VendasDatasetvalor_frete.BeforeLoadDFMValues;
  VendasDatasetvalor_ipi.BeforeLoadDFMValues;
  VendasDatasetvalor_outras.BeforeLoadDFMValues;
  VendasDatasetvalor_total_itens.BeforeLoadDFMValues;
  VendasDatasetvalor_total.BeforeLoadDFMValues;
  VendasDatasettransportadora_id.BeforeLoadDFMValues;
  VendasDatasetplaca_veiculo.BeforeLoadDFMValues;
  VendasDatasetvolumes_quantidade.BeforeLoadDFMValues;
  VendasDatasetvolumes_especie.BeforeLoadDFMValues;
  VendasDatasetvolumes_marca.BeforeLoadDFMValues;
  VendasDatasetvolumes_peso_bruto.BeforeLoadDFMValues;
  VendasDatasetvolumes_peso_liquido.BeforeLoadDFMValues;
  VendasDatasetfrete_por_conta.BeforeLoadDFMValues;
  VendasDatasetobservacoes_credito.BeforeLoadDFMValues;
  VendasDatasetobservacoes.BeforeLoadDFMValues;
  VendasDatasetnota_situacao.BeforeLoadDFMValues;
  VendasDatasetipi_compoe_base_icms.BeforeLoadDFMValues;
  VendasDatasetfrete_compoe_base_icms.BeforeLoadDFMValues;
  VendasDatasetseguro_compoe_base_icms.BeforeLoadDFMValues;
  VendasDatasetoutras_compoe_base_icms.BeforeLoadDFMValues;
  VendasDatasetvalor_isentas.BeforeLoadDFMValues;
  VendasDatasetcliente_fidelidade_id.BeforeLoadDFMValues;
  VendasDatasetnfe_id.BeforeLoadDFMValues;
  VendasDatasetnfse_id.BeforeLoadDFMValues;
  VendasDatasetosv_oss_id.BeforeLoadDFMValues;
  VendasDatasetose_oss_id.BeforeLoadDFMValues;
  VendasDatasetorcamentos_id.BeforeLoadDFMValues;
  VendasDatasetpet_vendas_id.BeforeLoadDFMValues;
  VendasDatasetpet_prontuarios_id.BeforeLoadDFMValues;
  VendasDatasetdata_entrega.BeforeLoadDFMValues;
  VendasDatasetdata_movimento.BeforeLoadDFMValues;
  VendasDatasetnome_consumidor_final.BeforeLoadDFMValues;
  VendasDatasetrotas_id.BeforeLoadDFMValues;
  VendasDatasetconvenios_id.BeforeLoadDFMValues;
  VendasDatasetdependentes_id.BeforeLoadDFMValues;
  VendasDatasetemissao_terceiros.BeforeLoadDFMValues;
  VendasDatasetchave_acesso_terceiros.BeforeLoadDFMValues;
  VendasDatasetmensalidade_id.BeforeLoadDFMValues;
  VendasDatasetcodigo_producao.BeforeLoadDFMValues;
  VendasDatasetsimples_faturamento.BeforeLoadDFMValues;
  VendasDatasetvalor_icms_desonerado.BeforeLoadDFMValues;
  VendasDatasetvalor_ipi_devolucao.BeforeLoadDFMValues;
  VendasDatasetexcluiu_icms_base_pis_cofins.BeforeLoadDFMValues;
  VendasDatasetvalor_fcp_st.BeforeLoadDFMValues;
  VendasDatasetvalor_retido_pis.BeforeLoadDFMValues;
  VendasDatasetvalor_retido_cofins.BeforeLoadDFMValues;
  VendasDatasetvalor_retido_csll.BeforeLoadDFMValues;
  VendasDatasetvalor_base_calculo_irrf.BeforeLoadDFMValues;
  VendasDatasetaliquota_irrf.BeforeLoadDFMValues;
  VendasDatasetvalor_retido_irrf.BeforeLoadDFMValues;
  VendasDatasetvalor_base_calculo_previdencia_social.BeforeLoadDFMValues;
  VendasDatasetaliquota_previdencia_social.BeforeLoadDFMValues;
  VendasDatasetvalor_previdencia_social.BeforeLoadDFMValues;
  VendasDatasetexcluiu_fcp_base_pis_cofins.BeforeLoadDFMValues;
  VendasDatasetcodigo_interno.BeforeLoadDFMValues;
  VendasDatasetexcluido.BeforeLoadDFMValues;
  VendasDatasetinclusao.BeforeLoadDFMValues;
  VendasDatasetalteracao.BeforeLoadDFMValues;
  VendasDatasetexclusao.BeforeLoadDFMValues;
  VendasDatasetfuncionarionome.BeforeLoadDFMValues;
  VendasDatasetclienterazao_social_nome.BeforeLoadDFMValues;
  VendasDatasetcfopnome.BeforeLoadDFMValues;
  VendasDatasetnfechave_acesso.BeforeLoadDFMValues;
  VendasDatasetnfenfe_cancelada.BeforeLoadDFMValues;
  VendasDatasetnfenfe_transmissao.BeforeLoadDFMValues;
  XDataClientVendasGet.BeforeLoadDFMValues;
  cdsItens.BeforeLoadDFMValues;
  cdsItensproduto_id.BeforeLoadDFMValues;
  cdsItensitem.BeforeLoadDFMValues;
  cdsItensquantidade.BeforeLoadDFMValues;
  cdsItensproduto_preco.BeforeLoadDFMValues;
  cdsItensvalor_total.BeforeLoadDFMValues;
  cdsItensprodnome.BeforeLoadDFMValues;
  cdsItensprodcodigo_interno.BeforeLoadDFMValues;
  cdsItensunidadesigla.BeforeLoadDFMValues;
  dtsItens.BeforeLoadDFMValues;
  tmrConsultaItens.BeforeLoadDFMValues;
  cdsRecebimentos.BeforeLoadDFMValues;
  cdsRecebimentosvalor_bruto_recebido.BeforeLoadDFMValues;
  cdsRecebimentosdata_recebimento.BeforeLoadDFMValues;
  cdsRecebimentosmodalidadenome.BeforeLoadDFMValues;
  cdsRecebimentosareceberdocumento.BeforeLoadDFMValues;
  cdsRecebimentosareceberparcela.BeforeLoadDFMValues;
  dtsRecebimentos.BeforeLoadDFMValues;
  dtsAReceber.BeforeLoadDFMValues;
  cdsAReceber.BeforeLoadDFMValues;
  cdsAReceberdocumento.BeforeLoadDFMValues;
  cdsAReceberparcela.BeforeLoadDFMValues;
  cdsAReceberemissao.BeforeLoadDFMValues;
  cdsARecebervencimento.BeforeLoadDFMValues;
  cdsARecebervalor_total.BeforeLoadDFMValues;
  cdsARecebervalor_saldo_pendente.BeforeLoadDFMValues;
  cdsARecebervalor_pago.BeforeLoadDFMValues;
  try
    Name := 'FViewVendasEdit';
    Width := 1118;
    Height := 630;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 208;
    lbid.Top := 186;
    lbid.Width := 70;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Servidor:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbcliente_id.SetParentComponent(Self);
    lbcliente_id.Name := 'lbcliente_id';
    lbcliente_id.Left := 8;
    lbcliente_id.Top := 25;
    lbcliente_id.Width := 37;
    lbcliente_id.Height := 13;
    lbcliente_id.Caption := 'Cliente:';
    lbcliente_id.HeightPercent := 100.000000000000000000;
    lbcliente_id.WidthPercent := 100.000000000000000000;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 8;
    lbfuncionario_id.Top := 52;
    lbfuncionario_id.Width := 59;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'Funcion'#225'rio:';
    lbfuncionario_id.HeightPercent := 100.000000000000000000;
    lbfuncionario_id.WidthPercent := 100.000000000000000000;
    lbcaixa.SetParentComponent(Self);
    lbcaixa.Name := 'lbcaixa';
    lbcaixa.Left := 208;
    lbcaixa.Top := 213;
    lbcaixa.Width := 31;
    lbcaixa.Height := 13;
    lbcaixa.Caption := 'Caixa:';
    lbcaixa.HeightPercent := 100.000000000000000000;
    lbcaixa.WidthPercent := 100.000000000000000000;
    lbcfop_cfop.SetParentComponent(Self);
    lbcfop_cfop.Name := 'lbcfop_cfop';
    lbcfop_cfop.Left := 8;
    lbcfop_cfop.Top := 79;
    lbcfop_cfop.Width := 31;
    lbcfop_cfop.Height := 13;
    lbcfop_cfop.Caption := 'CFOP:';
    lbcfop_cfop.HeightPercent := 100.000000000000000000;
    lbcfop_cfop.WidthPercent := 100.000000000000000000;
    lbnumero.SetParentComponent(Self);
    lbnumero.Name := 'lbnumero';
    lbnumero.Left := 8;
    lbnumero.Top := 106;
    lbnumero.Width := 58;
    lbnumero.Height := 13;
    lbnumero.Caption := 'Documento:';
    lbnumero.HeightPercent := 100.000000000000000000;
    lbnumero.WidthPercent := 100.000000000000000000;
    lbdoc_auxiliar.SetParentComponent(Self);
    lbdoc_auxiliar.Name := 'lbdoc_auxiliar';
    lbdoc_auxiliar.Left := 208;
    lbdoc_auxiliar.Top := 240;
    lbdoc_auxiliar.Width := 64;
    lbdoc_auxiliar.Height := 13;
    lbdoc_auxiliar.Caption := 'Doc. Auxiliar:';
    lbdoc_auxiliar.HeightPercent := 100.000000000000000000;
    lbdoc_auxiliar.WidthPercent := 100.000000000000000000;
    lbmodelo.SetParentComponent(Self);
    lbmodelo.Name := 'lbmodelo';
    lbmodelo.Left := 8;
    lbmodelo.Top := 132;
    lbmodelo.Width := 38;
    lbmodelo.Height := 13;
    lbmodelo.Caption := 'Modelo:';
    lbmodelo.HeightPercent := 100.000000000000000000;
    lbmodelo.WidthPercent := 100.000000000000000000;
    lbserie.SetParentComponent(Self);
    lbserie.Name := 'lbserie';
    lbserie.Left := 8;
    lbserie.Top := 159;
    lbserie.Width := 28;
    lbserie.Height := 13;
    lbserie.Caption := 'S'#233'rie:';
    lbserie.HeightPercent := 100.000000000000000000;
    lbserie.WidthPercent := 100.000000000000000000;
    lbsubserie.SetParentComponent(Self);
    lbsubserie.Name := 'lbsubserie';
    lbsubserie.Left := 8;
    lbsubserie.Top := 186;
    lbsubserie.Width := 49;
    lbsubserie.Height := 13;
    lbsubserie.Caption := 'Sub S'#233'rie:';
    lbsubserie.HeightPercent := 100.000000000000000000;
    lbsubserie.WidthPercent := 100.000000000000000000;
    lbdata_emissao.SetParentComponent(Self);
    lbdata_emissao.Name := 'lbdata_emissao';
    lbdata_emissao.Left := 8;
    lbdata_emissao.Top := 213;
    lbdata_emissao.Width := 42;
    lbdata_emissao.Height := 13;
    lbdata_emissao.Caption := 'Emiss'#227'o:';
    lbdata_emissao.HeightPercent := 100.000000000000000000;
    lbdata_emissao.WidthPercent := 100.000000000000000000;
    lbdata_saida.SetParentComponent(Self);
    lbdata_saida.Name := 'lbdata_saida';
    lbdata_saida.Left := 8;
    lbdata_saida.Top := 240;
    lbdata_saida.Width := 30;
    lbdata_saida.Height := 13;
    lbdata_saida.Caption := 'Sa'#237'da:';
    lbdata_saida.HeightPercent := 100.000000000000000000;
    lbdata_saida.WidthPercent := 100.000000000000000000;
    lbvalor_acrescimos.SetParentComponent(Self);
    lbvalor_acrescimos.Name := 'lbvalor_acrescimos';
    lbvalor_acrescimos.Left := 208;
    lbvalor_acrescimos.Top := 267;
    lbvalor_acrescimos.Width := 57;
    lbvalor_acrescimos.Height := 13;
    lbvalor_acrescimos.Caption := 'Acr'#233'scimos:';
    lbvalor_acrescimos.HeightPercent := 100.000000000000000000;
    lbvalor_acrescimos.WidthPercent := 100.000000000000000000;
    lbvalor_descontos.SetParentComponent(Self);
    lbvalor_descontos.Name := 'lbvalor_descontos';
    lbvalor_descontos.Left := 424;
    lbvalor_descontos.Top := 25;
    lbvalor_descontos.Width := 54;
    lbvalor_descontos.Height := 13;
    lbvalor_descontos.Caption := 'Descontos:';
    lbvalor_descontos.HeightPercent := 100.000000000000000000;
    lbvalor_descontos.WidthPercent := 100.000000000000000000;
    lbvalor_base_calculo_icms.SetParentComponent(Self);
    lbvalor_base_calculo_icms.Name := 'lbvalor_base_calculo_icms';
    lbvalor_base_calculo_icms.Left := 424;
    lbvalor_base_calculo_icms.Top := 52;
    lbvalor_base_calculo_icms.Width := 55;
    lbvalor_base_calculo_icms.Height := 13;
    lbvalor_base_calculo_icms.Caption := 'Base ICMS:';
    lbvalor_base_calculo_icms.HeightPercent := 100.000000000000000000;
    lbvalor_base_calculo_icms.WidthPercent := 100.000000000000000000;
    lbvalor_icms.SetParentComponent(Self);
    lbvalor_icms.Name := 'lbvalor_icms';
    lbvalor_icms.Left := 424;
    lbvalor_icms.Top := 79;
    lbvalor_icms.Width := 56;
    lbvalor_icms.Height := 13;
    lbvalor_icms.Caption := 'Valor ICMS:';
    lbvalor_icms.HeightPercent := 100.000000000000000000;
    lbvalor_icms.WidthPercent := 100.000000000000000000;
    lbvalor_base_calculo_st.SetParentComponent(Self);
    lbvalor_base_calculo_st.Name := 'lbvalor_base_calculo_st';
    lbvalor_base_calculo_st.Left := 424;
    lbvalor_base_calculo_st.Top := 106;
    lbvalor_base_calculo_st.Width := 42;
    lbvalor_base_calculo_st.Height := 13;
    lbvalor_base_calculo_st.Caption := 'Base ST:';
    lbvalor_base_calculo_st.HeightPercent := 100.000000000000000000;
    lbvalor_base_calculo_st.WidthPercent := 100.000000000000000000;
    lbvalor_st.SetParentComponent(Self);
    lbvalor_st.Name := 'lbvalor_st';
    lbvalor_st.Left := 424;
    lbvalor_st.Top := 133;
    lbvalor_st.Width := 43;
    lbvalor_st.Height := 13;
    lbvalor_st.Caption := 'Valor ST:';
    lbvalor_st.HeightPercent := 100.000000000000000000;
    lbvalor_st.WidthPercent := 100.000000000000000000;
    lbvalor_seguro.SetParentComponent(Self);
    lbvalor_seguro.Name := 'lbvalor_seguro';
    lbvalor_seguro.Left := 424;
    lbvalor_seguro.Top := 160;
    lbvalor_seguro.Width := 65;
    lbvalor_seguro.Height := 13;
    lbvalor_seguro.Caption := 'Valor Seguro:';
    lbvalor_seguro.HeightPercent := 100.000000000000000000;
    lbvalor_seguro.WidthPercent := 100.000000000000000000;
    lbvalor_frete.SetParentComponent(Self);
    lbvalor_frete.Name := 'lbvalor_frete';
    lbvalor_frete.Left := 424;
    lbvalor_frete.Top := 187;
    lbvalor_frete.Width := 57;
    lbvalor_frete.Height := 13;
    lbvalor_frete.Caption := 'Valor Frete:';
    lbvalor_frete.HeightPercent := 100.000000000000000000;
    lbvalor_frete.WidthPercent := 100.000000000000000000;
    lbvalor_ipi.SetParentComponent(Self);
    lbvalor_ipi.Name := 'lbvalor_ipi';
    lbvalor_ipi.Left := 424;
    lbvalor_ipi.Top := 214;
    lbvalor_ipi.Width := 45;
    lbvalor_ipi.Height := 13;
    lbvalor_ipi.Caption := 'Valor IPI:';
    lbvalor_ipi.HeightPercent := 100.000000000000000000;
    lbvalor_ipi.WidthPercent := 100.000000000000000000;
    lbvalor_outras.SetParentComponent(Self);
    lbvalor_outras.Name := 'lbvalor_outras';
    lbvalor_outras.Left := 424;
    lbvalor_outras.Top := 241;
    lbvalor_outras.Width := 64;
    lbvalor_outras.Height := 13;
    lbvalor_outras.Caption := 'Valor Outras:';
    lbvalor_outras.HeightPercent := 100.000000000000000000;
    lbvalor_outras.WidthPercent := 100.000000000000000000;
    lbvalor_total_itens.SetParentComponent(Self);
    lbvalor_total_itens.Name := 'lbvalor_total_itens';
    lbvalor_total_itens.Left := 424;
    lbvalor_total_itens.Top := 268;
    lbvalor_total_itens.Width := 56;
    lbvalor_total_itens.Height := 13;
    lbvalor_total_itens.Caption := 'Total Itens:';
    lbvalor_total_itens.HeightPercent := 100.000000000000000000;
    lbvalor_total_itens.WidthPercent := 100.000000000000000000;
    lbvalor_total.SetParentComponent(Self);
    lbvalor_total.Name := 'lbvalor_total';
    lbvalor_total.Left := 8;
    lbvalor_total.Top := 267;
    lbvalor_total.Width := 28;
    lbvalor_total.Height := 13;
    lbvalor_total.Caption := 'Total:';
    lbvalor_total.HeightPercent := 100.000000000000000000;
    lbvalor_total.WidthPercent := 100.000000000000000000;
    lbvolumes_quantidade.SetParentComponent(Self);
    lbvolumes_quantidade.Name := 'lbvolumes_quantidade';
    lbvolumes_quantidade.Left := 618;
    lbvolumes_quantidade.Top := 25;
    lbvolumes_quantidade.Width := 74;
    lbvolumes_quantidade.Height := 13;
    lbvolumes_quantidade.Caption := 'Qtde. Volumes:';
    lbvolumes_quantidade.HeightPercent := 100.000000000000000000;
    lbvolumes_quantidade.WidthPercent := 100.000000000000000000;
    lbvolumes_especie.SetParentComponent(Self);
    lbvolumes_especie.Name := 'lbvolumes_especie';
    lbvolumes_especie.Left := 618;
    lbvolumes_especie.Top := 52;
    lbvolumes_especie.Width := 61;
    lbvolumes_especie.Height := 13;
    lbvolumes_especie.Caption := 'Esp'#233'cie Vol.:';
    lbvolumes_especie.HeightPercent := 100.000000000000000000;
    lbvolumes_especie.WidthPercent := 100.000000000000000000;
    lbvolumes_marca.SetParentComponent(Self);
    lbvolumes_marca.Name := 'lbvolumes_marca';
    lbvolumes_marca.Left := 618;
    lbvolumes_marca.Top := 79;
    lbvolumes_marca.Width := 75;
    lbvolumes_marca.Height := 13;
    lbvolumes_marca.Caption := 'Marca Volumes:';
    lbvolumes_marca.HeightPercent := 100.000000000000000000;
    lbvolumes_marca.WidthPercent := 100.000000000000000000;
    lbvolumes_peso_bruto.SetParentComponent(Self);
    lbvolumes_peso_bruto.Name := 'lbvolumes_peso_bruto';
    lbvolumes_peso_bruto.Left := 618;
    lbvolumes_peso_bruto.Top := 106;
    lbvolumes_peso_bruto.Width := 77;
    lbvolumes_peso_bruto.Height := 13;
    lbvolumes_peso_bruto.Caption := 'Peso Bruto Vol.:';
    lbvolumes_peso_bruto.HeightPercent := 100.000000000000000000;
    lbvolumes_peso_bruto.WidthPercent := 100.000000000000000000;
    lbvolumes_peso_liquido.SetParentComponent(Self);
    lbvolumes_peso_liquido.Name := 'lbvolumes_peso_liquido';
    lbvolumes_peso_liquido.Left := 618;
    lbvolumes_peso_liquido.Top := 133;
    lbvolumes_peso_liquido.Width := 65;
    lbvolumes_peso_liquido.Height := 13;
    lbvolumes_peso_liquido.Caption := 'Peso liq. Vol.:';
    lbvolumes_peso_liquido.HeightPercent := 100.000000000000000000;
    lbvolumes_peso_liquido.WidthPercent := 100.000000000000000000;
    lbfrete_por_conta.SetParentComponent(Self);
    lbfrete_por_conta.Name := 'lbfrete_por_conta';
    lbfrete_por_conta.Left := 618;
    lbfrete_por_conta.Top := 160;
    lbfrete_por_conta.Width := 81;
    lbfrete_por_conta.Height := 13;
    lbfrete_por_conta.Caption := 'Frete Por Conta:';
    lbfrete_por_conta.HeightPercent := 100.000000000000000000;
    lbfrete_por_conta.WidthPercent := 100.000000000000000000;
    lbobservacoes_credito.SetParentComponent(Self);
    lbobservacoes_credito.Name := 'lbobservacoes_credito';
    lbobservacoes_credito.Left := 618;
    lbobservacoes_credito.Top := 187;
    lbobservacoes_credito.Width := 65;
    lbobservacoes_credito.Height := 13;
    lbobservacoes_credito.Caption := 'Obs. Cr'#233'dito:';
    lbobservacoes_credito.HeightPercent := 100.000000000000000000;
    lbobservacoes_credito.WidthPercent := 100.000000000000000000;
    lbobservacoes.SetParentComponent(Self);
    lbobservacoes.Name := 'lbobservacoes';
    lbobservacoes.Left := 618;
    lbobservacoes.Top := 214;
    lbobservacoes.Width := 67;
    lbobservacoes.Height := 13;
    lbobservacoes.Caption := 'Observa'#231#245'es:';
    lbobservacoes.HeightPercent := 100.000000000000000000;
    lbobservacoes.WidthPercent := 100.000000000000000000;
    lbnota_situacao.SetParentComponent(Self);
    lbnota_situacao.Name := 'lbnota_situacao';
    lbnota_situacao.Left := 208;
    lbnota_situacao.Top := 159;
    lbnota_situacao.Width := 71;
    lbnota_situacao.Height := 13;
    lbnota_situacao.Caption := 'Nota Situa'#231#227'o:';
    lbnota_situacao.HeightPercent := 100.000000000000000000;
    lbnota_situacao.WidthPercent := 100.000000000000000000;
    lbipi_compoe_base_icms.SetParentComponent(Self);
    lbipi_compoe_base_icms.Name := 'lbipi_compoe_base_icms';
    lbipi_compoe_base_icms.Left := 618;
    lbipi_compoe_base_icms.Top := 241;
    lbipi_compoe_base_icms.Width := 107;
    lbipi_compoe_base_icms.Height := 13;
    lbipi_compoe_base_icms.Caption := 'IPI Comp. Base ICMS?';
    lbipi_compoe_base_icms.HeightPercent := 100.000000000000000000;
    lbipi_compoe_base_icms.WidthPercent := 100.000000000000000000;
    lbfrete_compoe_base_icms.SetParentComponent(Self);
    lbfrete_compoe_base_icms.Name := 'lbfrete_compoe_base_icms';
    lbfrete_compoe_base_icms.Left := 618;
    lbfrete_compoe_base_icms.Top := 268;
    lbfrete_compoe_base_icms.Width := 119;
    lbfrete_compoe_base_icms.Height := 13;
    lbfrete_compoe_base_icms.Caption := 'Frete Comp. Base ICMS?';
    lbfrete_compoe_base_icms.HeightPercent := 100.000000000000000000;
    lbfrete_compoe_base_icms.WidthPercent := 100.000000000000000000;
    lbseguro_compoe_base_icms.SetParentComponent(Self);
    lbseguro_compoe_base_icms.Name := 'lbseguro_compoe_base_icms';
    lbseguro_compoe_base_icms.Left := 872;
    lbseguro_compoe_base_icms.Top := 25;
    lbseguro_compoe_base_icms.Width := 127;
    lbseguro_compoe_base_icms.Height := 13;
    lbseguro_compoe_base_icms.Caption := 'Seguro Comp. Base ICMS?';
    lbseguro_compoe_base_icms.HeightPercent := 100.000000000000000000;
    lbseguro_compoe_base_icms.WidthPercent := 100.000000000000000000;
    lboutras_compoe_base_icms.SetParentComponent(Self);
    lboutras_compoe_base_icms.Name := 'lboutras_compoe_base_icms';
    lboutras_compoe_base_icms.Left := 872;
    lboutras_compoe_base_icms.Top := 52;
    lboutras_compoe_base_icms.Width := 126;
    lboutras_compoe_base_icms.Height := 13;
    lboutras_compoe_base_icms.Caption := 'Outras Comp. Base ICMS?';
    lboutras_compoe_base_icms.HeightPercent := 100.000000000000000000;
    lboutras_compoe_base_icms.WidthPercent := 100.000000000000000000;
    lbvalor_isentas.SetParentComponent(Self);
    lbvalor_isentas.Name := 'lbvalor_isentas';
    lbvalor_isentas.Left := 872;
    lbvalor_isentas.Top := 79;
    lbvalor_isentas.Width := 67;
    lbvalor_isentas.Height := 13;
    lbvalor_isentas.Caption := 'Valor Isentas:';
    lbvalor_isentas.HeightPercent := 100.000000000000000000;
    lbvalor_isentas.WidthPercent := 100.000000000000000000;
    lbdata_entrega.SetParentComponent(Self);
    lbdata_entrega.Name := 'lbdata_entrega';
    lbdata_entrega.Left := 872;
    lbdata_entrega.Top := 106;
    lbdata_entrega.Width := 68;
    lbdata_entrega.Height := 13;
    lbdata_entrega.Caption := 'Data Entrega:';
    lbdata_entrega.HeightPercent := 100.000000000000000000;
    lbdata_entrega.WidthPercent := 100.000000000000000000;
    lbdata_movimento.SetParentComponent(Self);
    lbdata_movimento.Name := 'lbdata_movimento';
    lbdata_movimento.Left := 872;
    lbdata_movimento.Top := 133;
    lbdata_movimento.Width := 82;
    lbdata_movimento.Height := 13;
    lbdata_movimento.Caption := 'Data Movimento:';
    lbdata_movimento.HeightPercent := 100.000000000000000000;
    lbdata_movimento.WidthPercent := 100.000000000000000000;
    lbemissao_terceiros.SetParentComponent(Self);
    lbemissao_terceiros.Name := 'lbemissao_terceiros';
    lbemissao_terceiros.Left := 872;
    lbemissao_terceiros.Top := 160;
    lbemissao_terceiros.Width := 90;
    lbemissao_terceiros.Height := 13;
    lbemissao_terceiros.Caption := 'Emiss'#227'o Terceiros?';
    lbemissao_terceiros.HeightPercent := 100.000000000000000000;
    lbemissao_terceiros.WidthPercent := 100.000000000000000000;
    lbchave_acesso_terceiros.SetParentComponent(Self);
    lbchave_acesso_terceiros.Name := 'lbchave_acesso_terceiros';
    lbchave_acesso_terceiros.Left := 872;
    lbchave_acesso_terceiros.Top := 186;
    lbchave_acesso_terceiros.Width := 100;
    lbchave_acesso_terceiros.Height := 13;
    lbchave_acesso_terceiros.Caption := 'Chave Acesso Terc.:';
    lbchave_acesso_terceiros.HeightPercent := 100.000000000000000000;
    lbchave_acesso_terceiros.WidthPercent := 100.000000000000000000;
    lbsimples_faturamento.SetParentComponent(Self);
    lbsimples_faturamento.Name := 'lbsimples_faturamento';
    lbsimples_faturamento.Left := 872;
    lbsimples_faturamento.Top := 213;
    lbsimples_faturamento.Width := 105;
    lbsimples_faturamento.Height := 13;
    lbsimples_faturamento.Caption := 'Simples Faturamento?';
    lbsimples_faturamento.HeightPercent := 100.000000000000000000;
    lbsimples_faturamento.WidthPercent := 100.000000000000000000;
    lbvalor_icms_desonerado.SetParentComponent(Self);
    lbvalor_icms_desonerado.Name := 'lbvalor_icms_desonerado';
    lbvalor_icms_desonerado.Left := 873;
    lbvalor_icms_desonerado.Top := 240;
    lbvalor_icms_desonerado.Width := 81;
    lbvalor_icms_desonerado.Height := 13;
    lbvalor_icms_desonerado.Caption := 'Valor ICMS Des.:';
    lbvalor_icms_desonerado.HeightPercent := 100.000000000000000000;
    lbvalor_icms_desonerado.WidthPercent := 100.000000000000000000;
    lbvalor_ipi_devolucao.SetParentComponent(Self);
    lbvalor_ipi_devolucao.Name := 'lbvalor_ipi_devolucao';
    lbvalor_ipi_devolucao.Left := 872;
    lbvalor_ipi_devolucao.Top := 267;
    lbvalor_ipi_devolucao.Width := 71;
    lbvalor_ipi_devolucao.Height := 13;
    lbvalor_ipi_devolucao.Caption := 'Valor IPI Dev.:';
    lbvalor_ipi_devolucao.HeightPercent := 100.000000000000000000;
    lbvalor_ipi_devolucao.WidthPercent := 100.000000000000000000;
    lbexcluiu_icms_base_pis_cofins.SetParentComponent(Self);
    lbexcluiu_icms_base_pis_cofins.Name := 'lbexcluiu_icms_base_pis_cofins';
    lbexcluiu_icms_base_pis_cofins.Left := 619;
    lbexcluiu_icms_base_pis_cofins.Top := 291;
    lbexcluiu_icms_base_pis_cofins.Width := 141;
    lbexcluiu_icms_base_pis_cofins.Height := 13;
    lbexcluiu_icms_base_pis_cofins.Caption := 'Excluiu ICMS Base Pis Cofins?';
    lbexcluiu_icms_base_pis_cofins.HeightPercent := 100.000000000000000000;
    lbexcluiu_icms_base_pis_cofins.WidthPercent := 100.000000000000000000;
    lbvalor_fcp_st.SetParentComponent(Self);
    lbvalor_fcp_st.Name := 'lbvalor_fcp_st';
    lbvalor_fcp_st.Left := 424;
    lbvalor_fcp_st.Top := 345;
    lbvalor_fcp_st.Width := 65;
    lbvalor_fcp_st.Height := 13;
    lbvalor_fcp_st.Caption := 'Valor FCP ST:';
    lbvalor_fcp_st.HeightPercent := 100.000000000000000000;
    lbvalor_fcp_st.WidthPercent := 100.000000000000000000;
    lbvalor_retido_pis.SetParentComponent(Self);
    lbvalor_retido_pis.Name := 'lbvalor_retido_pis';
    lbvalor_retido_pis.Left := 8;
    lbvalor_retido_pis.Top := 291;
    lbvalor_retido_pis.Width := 71;
    lbvalor_retido_pis.Height := 13;
    lbvalor_retido_pis.Caption := 'Valor Ret. PIS:';
    lbvalor_retido_pis.HeightPercent := 100.000000000000000000;
    lbvalor_retido_pis.WidthPercent := 100.000000000000000000;
    lbvalor_retido_cofins.SetParentComponent(Self);
    lbvalor_retido_cofins.Name := 'lbvalor_retido_cofins';
    lbvalor_retido_cofins.Left := 8;
    lbvalor_retido_cofins.Top := 318;
    lbvalor_retido_cofins.Width := 93;
    lbvalor_retido_cofins.Height := 13;
    lbvalor_retido_cofins.Caption := 'Valor Ret. COFINS:';
    lbvalor_retido_cofins.HeightPercent := 100.000000000000000000;
    lbvalor_retido_cofins.WidthPercent := 100.000000000000000000;
    lbvalor_retido_csll.SetParentComponent(Self);
    lbvalor_retido_csll.Name := 'lbvalor_retido_csll';
    lbvalor_retido_csll.Left := 8;
    lbvalor_retido_csll.Top := 345;
    lbvalor_retido_csll.Width := 78;
    lbvalor_retido_csll.Height := 13;
    lbvalor_retido_csll.Caption := 'Valor Ret. CSLL:';
    lbvalor_retido_csll.HeightPercent := 100.000000000000000000;
    lbvalor_retido_csll.WidthPercent := 100.000000000000000000;
    lbvalor_base_calculo_irrf.SetParentComponent(Self);
    lbvalor_base_calculo_irrf.Name := 'lbvalor_base_calculo_irrf';
    lbvalor_base_calculo_irrf.Left := 208;
    lbvalor_base_calculo_irrf.Top := 291;
    lbvalor_base_calculo_irrf.Width := 108;
    lbvalor_base_calculo_irrf.Height := 13;
    lbvalor_base_calculo_irrf.Caption := 'Valor Base Calc. IRRF:';
    lbvalor_base_calculo_irrf.HeightPercent := 100.000000000000000000;
    lbvalor_base_calculo_irrf.WidthPercent := 100.000000000000000000;
    lbaliquota_irrf.SetParentComponent(Self);
    lbaliquota_irrf.Name := 'lbaliquota_irrf';
    lbaliquota_irrf.Left := 208;
    lbaliquota_irrf.Top := 318;
    lbaliquota_irrf.Width := 70;
    lbaliquota_irrf.Height := 13;
    lbaliquota_irrf.Caption := 'Al'#237'quota IRRF:';
    lbaliquota_irrf.HeightPercent := 100.000000000000000000;
    lbaliquota_irrf.WidthPercent := 100.000000000000000000;
    lbvalor_retido_irrf.SetParentComponent(Self);
    lbvalor_retido_irrf.Name := 'lbvalor_retido_irrf';
    lbvalor_retido_irrf.Left := 208;
    lbvalor_retido_irrf.Top := 345;
    lbvalor_retido_irrf.Width := 79;
    lbvalor_retido_irrf.Height := 13;
    lbvalor_retido_irrf.Caption := 'Valor Ret. IRRF:';
    lbvalor_retido_irrf.HeightPercent := 100.000000000000000000;
    lbvalor_retido_irrf.WidthPercent := 100.000000000000000000;
    lbvalor_base_calculo_previdencia_social.SetParentComponent(Self);
    lbvalor_base_calculo_previdencia_social.Name := 'lbvalor_base_calculo_previdencia_social';
    lbvalor_base_calculo_previdencia_social.Left := 618;
    lbvalor_base_calculo_previdencia_social.Top := 318;
    lbvalor_base_calculo_previdencia_social.Width := 140;
    lbvalor_base_calculo_previdencia_social.Height := 13;
    lbvalor_base_calculo_previdencia_social.Caption := 'Valor Base Calc. Prev. Social:';
    lbvalor_base_calculo_previdencia_social.HeightPercent := 100.000000000000000000;
    lbvalor_base_calculo_previdencia_social.WidthPercent := 100.000000000000000000;
    lbaliquota_previdencia_social.SetParentComponent(Self);
    lbaliquota_previdencia_social.Name := 'lbaliquota_previdencia_social';
    lbaliquota_previdencia_social.Left := 424;
    lbaliquota_previdencia_social.Top := 291;
    lbaliquota_previdencia_social.Width := 84;
    lbaliquota_previdencia_social.Height := 13;
    lbaliquota_previdencia_social.Caption := 'Aliq. Prev. Social:';
    lbaliquota_previdencia_social.HeightPercent := 100.000000000000000000;
    lbaliquota_previdencia_social.WidthPercent := 100.000000000000000000;
    lbvalor_previdencia_social.SetParentComponent(Self);
    lbvalor_previdencia_social.Name := 'lbvalor_previdencia_social';
    lbvalor_previdencia_social.Left := 424;
    lbvalor_previdencia_social.Top := 318;
    lbvalor_previdencia_social.Width := 87;
    lbvalor_previdencia_social.Height := 13;
    lbvalor_previdencia_social.Caption := 'Valor Prev. Social:';
    lbvalor_previdencia_social.HeightPercent := 100.000000000000000000;
    lbvalor_previdencia_social.WidthPercent := 100.000000000000000000;
    lbexcluiu_fcp_base_pis_cofins.SetParentComponent(Self);
    lbexcluiu_fcp_base_pis_cofins.Name := 'lbexcluiu_fcp_base_pis_cofins';
    lbexcluiu_fcp_base_pis_cofins.Left := 618;
    lbexcluiu_fcp_base_pis_cofins.Top := 345;
    lbexcluiu_fcp_base_pis_cofins.Width := 135;
    lbexcluiu_fcp_base_pis_cofins.Height := 13;
    lbexcluiu_fcp_base_pis_cofins.Caption := 'Excluiu FCP Base Pis Cofins?';
    lbexcluiu_fcp_base_pis_cofins.HeightPercent := 100.000000000000000000;
    lbexcluiu_fcp_base_pis_cofins.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 208;
    lbcodigo_interno.Top := 25;
    lbcodigo_interno.Width := 87;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Retaguarda:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 208;
    lbexcluido.Top := 52;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 208;
    lbinclusao.Top := 79;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 208;
    lbalteracao.Top := 106;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 208;
    lbexclusao.Top := 133;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbPaginationInfoItens.SetParentComponent(Self);
    lbPaginationInfoItens.Name := 'lbPaginationInfoItens';
    lbPaginationInfoItens.Left := 8;
    lbPaginationInfoItens.Top := 559;
    lbPaginationInfoItens.Width := 141;
    lbPaginationInfoItens.Height := 13;
    lbPaginationInfoItens.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoItens.HeightPercent := 100.000000000000000000;
    lbPaginationInfoItens.WidthPercent := 100.000000000000000000;
    lbPaginationInfoAReceber.SetParentComponent(Self);
    lbPaginationInfoAReceber.Name := 'lbPaginationInfoAReceber';
    lbPaginationInfoAReceber.Left := 246;
    lbPaginationInfoAReceber.Top := 559;
    lbPaginationInfoAReceber.Width := 141;
    lbPaginationInfoAReceber.Height := 13;
    lbPaginationInfoAReceber.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoAReceber.Color := clBtnFace;
    lbPaginationInfoAReceber.HeightPercent := 100.000000000000000000;
    lbPaginationInfoAReceber.WidthPercent := 100.000000000000000000;
    lbPaginationInfoRecebimentos.SetParentComponent(Self);
    lbPaginationInfoRecebimentos.Name := 'lbPaginationInfoRecebimentos';
    lbPaginationInfoRecebimentos.Left := 488;
    lbPaginationInfoRecebimentos.Top := 559;
    lbPaginationInfoRecebimentos.Width := 141;
    lbPaginationInfoRecebimentos.Height := 13;
    lbPaginationInfoRecebimentos.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoRecebimentos.Color := clBtnFace;
    lbPaginationInfoRecebimentos.HeightPercent := 100.000000000000000000;
    lbPaginationInfoRecebimentos.WidthPercent := 100.000000000000000000;
    lbchave_acesso.SetParentComponent(Self);
    lbchave_acesso.Name := 'lbchave_acesso';
    lbchave_acesso.Left := 737;
    lbchave_acesso.Top := 422;
    lbchave_acesso.Width := 87;
    lbchave_acesso.Height := 13;
    lbchave_acesso.Caption := 'Chave de Acesso:';
    lbchave_acesso.HeightPercent := 100.000000000000000000;
    lbchave_acesso.WidthPercent := 100.000000000000000000;
    lbnfe_transmissao.SetParentComponent(Self);
    lbnfe_transmissao.Name := 'lbnfe_transmissao';
    lbnfe_transmissao.Left := 737;
    lbnfe_transmissao.Top := 448;
    lbnfe_transmissao.Width := 89;
    lbnfe_transmissao.Height := 13;
    lbnfe_transmissao.Caption := 'Data Transmiss'#227'o:';
    lbnfe_transmissao.HeightPercent := 100.000000000000000000;
    lbnfe_transmissao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 8;
    btCancel.Top := 369;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 317;
    edid.Top := 183;
    edid.Width := 100;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edcliente_id.SetParentComponent(Self);
    edcliente_id.Name := 'edcliente_id';
    edcliente_id.Left := 104;
    edcliente_id.Top := 22;
    edcliente_id.Width := 100;
    edcliente_id.Height := 21;
    edcliente_id.Enabled := False;
    edcliente_id.HeightPercent := 100.000000000000000000;
    edcliente_id.TabOrder := 9;
    edcliente_id.Text := 'edcliente_id';
    edcliente_id.WidthPercent := 100.000000000000000000;
    edcliente_id.DataField := 'cliente.razao_social_nome';
    edcliente_id.DataSource := DataSource;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 104;
    edfuncionario_id.Top := 49;
    edfuncionario_id.Width := 100;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := False;
    edfuncionario_id.HeightPercent := 100.000000000000000000;
    edfuncionario_id.TabOrder := 10;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.WidthPercent := 100.000000000000000000;
    edfuncionario_id.DataField := 'funcionario.nome';
    edfuncionario_id.DataSource := DataSource;
    edcaixa.SetParentComponent(Self);
    edcaixa.Name := 'edcaixa';
    edcaixa.Left := 317;
    edcaixa.Top := 210;
    edcaixa.Width := 100;
    edcaixa.Height := 21;
    edcaixa.Enabled := False;
    edcaixa.HeightPercent := 100.000000000000000000;
    edcaixa.TabOrder := 11;
    edcaixa.Text := 'edcaixa';
    edcaixa.WidthPercent := 100.000000000000000000;
    edcaixa.DataField := 'caixa';
    edcaixa.DataSource := DataSource;
    edcfop_cfop.SetParentComponent(Self);
    edcfop_cfop.Name := 'edcfop_cfop';
    edcfop_cfop.Left := 104;
    edcfop_cfop.Top := 76;
    edcfop_cfop.Width := 100;
    edcfop_cfop.Height := 21;
    edcfop_cfop.Enabled := False;
    edcfop_cfop.HeightPercent := 100.000000000000000000;
    edcfop_cfop.TabOrder := 12;
    edcfop_cfop.Text := 'edcfop_cfop';
    edcfop_cfop.WidthPercent := 100.000000000000000000;
    edcfop_cfop.DataField := 'cfop_cfop';
    edcfop_cfop.DataSource := DataSource;
    ednumero.SetParentComponent(Self);
    ednumero.Name := 'ednumero';
    ednumero.Left := 104;
    ednumero.Top := 103;
    ednumero.Width := 100;
    ednumero.Height := 21;
    ednumero.Enabled := False;
    ednumero.HeightPercent := 100.000000000000000000;
    ednumero.TabOrder := 13;
    ednumero.Text := 'ednumero';
    ednumero.WidthPercent := 100.000000000000000000;
    ednumero.DataField := 'numero';
    ednumero.DataSource := DataSource;
    eddoc_auxiliar.SetParentComponent(Self);
    eddoc_auxiliar.Name := 'eddoc_auxiliar';
    eddoc_auxiliar.Left := 317;
    eddoc_auxiliar.Top := 237;
    eddoc_auxiliar.Width := 100;
    eddoc_auxiliar.Height := 21;
    eddoc_auxiliar.Enabled := False;
    eddoc_auxiliar.HeightPercent := 100.000000000000000000;
    eddoc_auxiliar.TabOrder := 14;
    eddoc_auxiliar.Text := 'eddoc_auxiliar';
    eddoc_auxiliar.WidthPercent := 100.000000000000000000;
    eddoc_auxiliar.DataField := 'doc_auxiliar';
    eddoc_auxiliar.DataSource := DataSource;
    edmodelo.SetParentComponent(Self);
    edmodelo.Name := 'edmodelo';
    edmodelo.Left := 104;
    edmodelo.Top := 129;
    edmodelo.Width := 100;
    edmodelo.Height := 21;
    edmodelo.Enabled := False;
    edmodelo.HeightPercent := 100.000000000000000000;
    edmodelo.TabOrder := 15;
    edmodelo.Text := 'edmodelo';
    edmodelo.WidthPercent := 100.000000000000000000;
    edmodelo.DataField := 'modelo';
    edmodelo.DataSource := DataSource;
    edserie.SetParentComponent(Self);
    edserie.Name := 'edserie';
    edserie.Left := 104;
    edserie.Top := 156;
    edserie.Width := 100;
    edserie.Height := 21;
    edserie.Enabled := False;
    edserie.HeightPercent := 100.000000000000000000;
    edserie.TabOrder := 16;
    edserie.Text := 'edserie';
    edserie.WidthPercent := 100.000000000000000000;
    edserie.DataField := 'serie';
    edserie.DataSource := DataSource;
    edsubserie.SetParentComponent(Self);
    edsubserie.Name := 'edsubserie';
    edsubserie.Left := 104;
    edsubserie.Top := 183;
    edsubserie.Width := 100;
    edsubserie.Height := 21;
    edsubserie.Enabled := False;
    edsubserie.HeightPercent := 100.000000000000000000;
    edsubserie.TabOrder := 17;
    edsubserie.Text := 'edsubserie';
    edsubserie.WidthPercent := 100.000000000000000000;
    edsubserie.DataField := 'subserie';
    edsubserie.DataSource := DataSource;
    eddata_emissao.SetParentComponent(Self);
    eddata_emissao.Name := 'eddata_emissao';
    eddata_emissao.Left := 104;
    eddata_emissao.Top := 210;
    eddata_emissao.Width := 100;
    eddata_emissao.Height := 21;
    eddata_emissao.Enabled := False;
    eddata_emissao.HeightPercent := 100.000000000000000000;
    eddata_emissao.TabOrder := 18;
    eddata_emissao.Text := 'eddata_emissao';
    eddata_emissao.WidthPercent := 100.000000000000000000;
    eddata_emissao.DataField := 'data_emissao';
    eddata_emissao.DataSource := DataSource;
    eddata_saida.SetParentComponent(Self);
    eddata_saida.Name := 'eddata_saida';
    eddata_saida.Left := 104;
    eddata_saida.Top := 237;
    eddata_saida.Width := 100;
    eddata_saida.Height := 21;
    eddata_saida.Enabled := False;
    eddata_saida.HeightPercent := 100.000000000000000000;
    eddata_saida.TabOrder := 19;
    eddata_saida.Text := 'eddata_saida';
    eddata_saida.WidthPercent := 100.000000000000000000;
    eddata_saida.DataField := 'data_saida';
    eddata_saida.DataSource := DataSource;
    edvalor_acrescimos.SetParentComponent(Self);
    edvalor_acrescimos.Name := 'edvalor_acrescimos';
    edvalor_acrescimos.Left := 317;
    edvalor_acrescimos.Top := 264;
    edvalor_acrescimos.Width := 100;
    edvalor_acrescimos.Height := 21;
    edvalor_acrescimos.Enabled := False;
    edvalor_acrescimos.HeightPercent := 100.000000000000000000;
    edvalor_acrescimos.TabOrder := 20;
    edvalor_acrescimos.Text := 'edvalor_acrescimos';
    edvalor_acrescimos.WidthPercent := 100.000000000000000000;
    edvalor_acrescimos.DataField := 'valor_acrescimos';
    edvalor_acrescimos.DataSource := DataSource;
    edvalor_descontos.SetParentComponent(Self);
    edvalor_descontos.Name := 'edvalor_descontos';
    edvalor_descontos.Left := 513;
    edvalor_descontos.Top := 22;
    edvalor_descontos.Width := 100;
    edvalor_descontos.Height := 21;
    edvalor_descontos.Enabled := False;
    edvalor_descontos.HeightPercent := 100.000000000000000000;
    edvalor_descontos.TabOrder := 21;
    edvalor_descontos.Text := 'edvalor_descontos';
    edvalor_descontos.WidthPercent := 100.000000000000000000;
    edvalor_descontos.DataField := 'valor_descontos';
    edvalor_descontos.DataSource := DataSource;
    edvalor_base_calculo_icms.SetParentComponent(Self);
    edvalor_base_calculo_icms.Name := 'edvalor_base_calculo_icms';
    edvalor_base_calculo_icms.Left := 513;
    edvalor_base_calculo_icms.Top := 49;
    edvalor_base_calculo_icms.Width := 100;
    edvalor_base_calculo_icms.Height := 21;
    edvalor_base_calculo_icms.Enabled := False;
    edvalor_base_calculo_icms.HeightPercent := 100.000000000000000000;
    edvalor_base_calculo_icms.TabOrder := 22;
    edvalor_base_calculo_icms.Text := 'edvalor_base_calculo_icms';
    edvalor_base_calculo_icms.WidthPercent := 100.000000000000000000;
    edvalor_base_calculo_icms.DataField := 'valor_base_calculo_icms';
    edvalor_base_calculo_icms.DataSource := DataSource;
    edvalor_icms.SetParentComponent(Self);
    edvalor_icms.Name := 'edvalor_icms';
    edvalor_icms.Left := 513;
    edvalor_icms.Top := 76;
    edvalor_icms.Width := 100;
    edvalor_icms.Height := 21;
    edvalor_icms.Enabled := False;
    edvalor_icms.HeightPercent := 100.000000000000000000;
    edvalor_icms.TabOrder := 23;
    edvalor_icms.Text := 'edvalor_icms';
    edvalor_icms.WidthPercent := 100.000000000000000000;
    edvalor_icms.DataField := 'valor_icms';
    edvalor_icms.DataSource := DataSource;
    edvalor_base_calculo_st.SetParentComponent(Self);
    edvalor_base_calculo_st.Name := 'edvalor_base_calculo_st';
    edvalor_base_calculo_st.Left := 513;
    edvalor_base_calculo_st.Top := 103;
    edvalor_base_calculo_st.Width := 100;
    edvalor_base_calculo_st.Height := 21;
    edvalor_base_calculo_st.Enabled := False;
    edvalor_base_calculo_st.HeightPercent := 100.000000000000000000;
    edvalor_base_calculo_st.TabOrder := 24;
    edvalor_base_calculo_st.Text := 'edvalor_base_calculo_st';
    edvalor_base_calculo_st.WidthPercent := 100.000000000000000000;
    edvalor_base_calculo_st.DataField := 'valor_base_calculo_st';
    edvalor_base_calculo_st.DataSource := DataSource;
    edvalor_st.SetParentComponent(Self);
    edvalor_st.Name := 'edvalor_st';
    edvalor_st.Left := 513;
    edvalor_st.Top := 130;
    edvalor_st.Width := 100;
    edvalor_st.Height := 21;
    edvalor_st.Enabled := False;
    edvalor_st.HeightPercent := 100.000000000000000000;
    edvalor_st.TabOrder := 25;
    edvalor_st.Text := 'edvalor_st';
    edvalor_st.WidthPercent := 100.000000000000000000;
    edvalor_st.DataField := 'valor_st';
    edvalor_st.DataSource := DataSource;
    edvalor_seguro.SetParentComponent(Self);
    edvalor_seguro.Name := 'edvalor_seguro';
    edvalor_seguro.Left := 513;
    edvalor_seguro.Top := 157;
    edvalor_seguro.Width := 100;
    edvalor_seguro.Height := 21;
    edvalor_seguro.Enabled := False;
    edvalor_seguro.HeightPercent := 100.000000000000000000;
    edvalor_seguro.TabOrder := 26;
    edvalor_seguro.Text := 'edvalor_seguro';
    edvalor_seguro.WidthPercent := 100.000000000000000000;
    edvalor_seguro.DataField := 'valor_seguro';
    edvalor_seguro.DataSource := DataSource;
    edvalor_frete.SetParentComponent(Self);
    edvalor_frete.Name := 'edvalor_frete';
    edvalor_frete.Left := 513;
    edvalor_frete.Top := 184;
    edvalor_frete.Width := 100;
    edvalor_frete.Height := 21;
    edvalor_frete.Enabled := False;
    edvalor_frete.HeightPercent := 100.000000000000000000;
    edvalor_frete.TabOrder := 27;
    edvalor_frete.Text := 'edvalor_frete';
    edvalor_frete.WidthPercent := 100.000000000000000000;
    edvalor_frete.DataField := 'valor_frete';
    edvalor_frete.DataSource := DataSource;
    edvalor_ipi.SetParentComponent(Self);
    edvalor_ipi.Name := 'edvalor_ipi';
    edvalor_ipi.Left := 513;
    edvalor_ipi.Top := 211;
    edvalor_ipi.Width := 100;
    edvalor_ipi.Height := 21;
    edvalor_ipi.Enabled := False;
    edvalor_ipi.HeightPercent := 100.000000000000000000;
    edvalor_ipi.TabOrder := 28;
    edvalor_ipi.Text := 'edvalor_ipi';
    edvalor_ipi.WidthPercent := 100.000000000000000000;
    edvalor_ipi.DataField := 'valor_ipi';
    edvalor_ipi.DataSource := DataSource;
    edvalor_outras.SetParentComponent(Self);
    edvalor_outras.Name := 'edvalor_outras';
    edvalor_outras.Left := 513;
    edvalor_outras.Top := 238;
    edvalor_outras.Width := 100;
    edvalor_outras.Height := 21;
    edvalor_outras.Enabled := False;
    edvalor_outras.HeightPercent := 100.000000000000000000;
    edvalor_outras.TabOrder := 29;
    edvalor_outras.Text := 'edvalor_outras';
    edvalor_outras.WidthPercent := 100.000000000000000000;
    edvalor_outras.DataField := 'valor_outras';
    edvalor_outras.DataSource := DataSource;
    edvalor_total_itens.SetParentComponent(Self);
    edvalor_total_itens.Name := 'edvalor_total_itens';
    edvalor_total_itens.Left := 513;
    edvalor_total_itens.Top := 265;
    edvalor_total_itens.Width := 100;
    edvalor_total_itens.Height := 21;
    edvalor_total_itens.Enabled := False;
    edvalor_total_itens.HeightPercent := 100.000000000000000000;
    edvalor_total_itens.TabOrder := 30;
    edvalor_total_itens.Text := 'edvalor_total_itens';
    edvalor_total_itens.WidthPercent := 100.000000000000000000;
    edvalor_total_itens.DataField := 'valor_total_itens';
    edvalor_total_itens.DataSource := DataSource;
    edvalor_total.SetParentComponent(Self);
    edvalor_total.Name := 'edvalor_total';
    edvalor_total.Left := 104;
    edvalor_total.Top := 264;
    edvalor_total.Width := 100;
    edvalor_total.Height := 21;
    edvalor_total.Enabled := False;
    edvalor_total.HeightPercent := 100.000000000000000000;
    edvalor_total.TabOrder := 31;
    edvalor_total.Text := 'edvalor_total';
    edvalor_total.WidthPercent := 100.000000000000000000;
    edvalor_total.DataField := 'valor_total';
    edvalor_total.DataSource := DataSource;
    edvolumes_quantidade.SetParentComponent(Self);
    edvolumes_quantidade.Name := 'edvolumes_quantidade';
    edvolumes_quantidade.Left := 766;
    edvolumes_quantidade.Top := 22;
    edvolumes_quantidade.Width := 100;
    edvolumes_quantidade.Height := 21;
    edvolumes_quantidade.Enabled := False;
    edvolumes_quantidade.HeightPercent := 100.000000000000000000;
    edvolumes_quantidade.TabOrder := 34;
    edvolumes_quantidade.Text := 'edvolumes_quantidade';
    edvolumes_quantidade.WidthPercent := 100.000000000000000000;
    edvolumes_quantidade.DataField := 'volumes_quantidade';
    edvolumes_quantidade.DataSource := DataSource;
    edvolumes_especie.SetParentComponent(Self);
    edvolumes_especie.Name := 'edvolumes_especie';
    edvolumes_especie.Left := 766;
    edvolumes_especie.Top := 49;
    edvolumes_especie.Width := 100;
    edvolumes_especie.Height := 21;
    edvolumes_especie.Enabled := False;
    edvolumes_especie.HeightPercent := 100.000000000000000000;
    edvolumes_especie.TabOrder := 35;
    edvolumes_especie.Text := 'edvolumes_especie';
    edvolumes_especie.WidthPercent := 100.000000000000000000;
    edvolumes_especie.DataField := 'volumes_especie';
    edvolumes_especie.DataSource := DataSource;
    edvolumes_marca.SetParentComponent(Self);
    edvolumes_marca.Name := 'edvolumes_marca';
    edvolumes_marca.Left := 766;
    edvolumes_marca.Top := 76;
    edvolumes_marca.Width := 100;
    edvolumes_marca.Height := 21;
    edvolumes_marca.Enabled := False;
    edvolumes_marca.HeightPercent := 100.000000000000000000;
    edvolumes_marca.TabOrder := 36;
    edvolumes_marca.Text := 'edvolumes_marca';
    edvolumes_marca.WidthPercent := 100.000000000000000000;
    edvolumes_marca.DataField := 'volumes_marca';
    edvolumes_marca.DataSource := DataSource;
    edvolumes_peso_bruto.SetParentComponent(Self);
    edvolumes_peso_bruto.Name := 'edvolumes_peso_bruto';
    edvolumes_peso_bruto.Left := 766;
    edvolumes_peso_bruto.Top := 103;
    edvolumes_peso_bruto.Width := 100;
    edvolumes_peso_bruto.Height := 21;
    edvolumes_peso_bruto.Enabled := False;
    edvolumes_peso_bruto.HeightPercent := 100.000000000000000000;
    edvolumes_peso_bruto.TabOrder := 37;
    edvolumes_peso_bruto.Text := 'edvolumes_peso_bruto';
    edvolumes_peso_bruto.WidthPercent := 100.000000000000000000;
    edvolumes_peso_bruto.DataField := 'volumes_peso_bruto';
    edvolumes_peso_bruto.DataSource := DataSource;
    edvolumes_peso_liquido.SetParentComponent(Self);
    edvolumes_peso_liquido.Name := 'edvolumes_peso_liquido';
    edvolumes_peso_liquido.Left := 766;
    edvolumes_peso_liquido.Top := 130;
    edvolumes_peso_liquido.Width := 100;
    edvolumes_peso_liquido.Height := 21;
    edvolumes_peso_liquido.Enabled := False;
    edvolumes_peso_liquido.HeightPercent := 100.000000000000000000;
    edvolumes_peso_liquido.TabOrder := 38;
    edvolumes_peso_liquido.Text := 'edvolumes_peso_liquido';
    edvolumes_peso_liquido.WidthPercent := 100.000000000000000000;
    edvolumes_peso_liquido.DataField := 'volumes_peso_liquido';
    edvolumes_peso_liquido.DataSource := DataSource;
    edfrete_por_conta.SetParentComponent(Self);
    edfrete_por_conta.Name := 'edfrete_por_conta';
    edfrete_por_conta.Left := 766;
    edfrete_por_conta.Top := 157;
    edfrete_por_conta.Width := 100;
    edfrete_por_conta.Height := 21;
    edfrete_por_conta.Enabled := False;
    edfrete_por_conta.HeightPercent := 100.000000000000000000;
    edfrete_por_conta.TabOrder := 39;
    edfrete_por_conta.Text := 'edfrete_por_conta';
    edfrete_por_conta.WidthPercent := 100.000000000000000000;
    edfrete_por_conta.DataField := 'frete_por_conta';
    edfrete_por_conta.DataSource := DataSource;
    edobservacoes_credito.SetParentComponent(Self);
    edobservacoes_credito.Name := 'edobservacoes_credito';
    edobservacoes_credito.Left := 766;
    edobservacoes_credito.Top := 184;
    edobservacoes_credito.Width := 100;
    edobservacoes_credito.Height := 21;
    edobservacoes_credito.Enabled := False;
    edobservacoes_credito.HeightPercent := 100.000000000000000000;
    edobservacoes_credito.TabOrder := 40;
    edobservacoes_credito.Text := 'edobservacoes_credito';
    edobservacoes_credito.WidthPercent := 100.000000000000000000;
    edobservacoes_credito.DataField := 'observacoes_credito';
    edobservacoes_credito.DataSource := DataSource;
    edobservacoes.SetParentComponent(Self);
    edobservacoes.Name := 'edobservacoes';
    edobservacoes.Left := 766;
    edobservacoes.Top := 211;
    edobservacoes.Width := 100;
    edobservacoes.Height := 21;
    edobservacoes.Enabled := False;
    edobservacoes.HeightPercent := 100.000000000000000000;
    edobservacoes.TabOrder := 41;
    edobservacoes.Text := 'edobservacoes';
    edobservacoes.WidthPercent := 100.000000000000000000;
    edobservacoes.DataField := 'observacoes';
    edobservacoes.DataSource := DataSource;
    ednota_situacao.SetParentComponent(Self);
    ednota_situacao.Name := 'ednota_situacao';
    ednota_situacao.Left := 317;
    ednota_situacao.Top := 156;
    ednota_situacao.Width := 100;
    ednota_situacao.Height := 21;
    ednota_situacao.Enabled := False;
    ednota_situacao.HeightPercent := 100.000000000000000000;
    ednota_situacao.TabOrder := 42;
    ednota_situacao.Text := 'ednota_situacao';
    ednota_situacao.WidthPercent := 100.000000000000000000;
    ednota_situacao.DataField := 'nota_situacao';
    ednota_situacao.DataSource := DataSource;
    edvalor_isentas.SetParentComponent(Self);
    edvalor_isentas.Name := 'edvalor_isentas';
    edvalor_isentas.Left := 1005;
    edvalor_isentas.Top := 76;
    edvalor_isentas.Width := 100;
    edvalor_isentas.Height := 21;
    edvalor_isentas.Enabled := False;
    edvalor_isentas.HeightPercent := 100.000000000000000000;
    edvalor_isentas.TabOrder := 47;
    edvalor_isentas.Text := 'edvalor_isentas';
    edvalor_isentas.WidthPercent := 100.000000000000000000;
    edvalor_isentas.DataField := 'valor_isentas';
    edvalor_isentas.DataSource := DataSource;
    eddata_entrega.SetParentComponent(Self);
    eddata_entrega.Name := 'eddata_entrega';
    eddata_entrega.Left := 1005;
    eddata_entrega.Top := 103;
    eddata_entrega.Width := 100;
    eddata_entrega.Height := 21;
    eddata_entrega.Enabled := False;
    eddata_entrega.HeightPercent := 100.000000000000000000;
    eddata_entrega.TabOrder := 56;
    eddata_entrega.Text := 'eddata_entrega';
    eddata_entrega.WidthPercent := 100.000000000000000000;
    eddata_entrega.DataField := 'data_entrega';
    eddata_entrega.DataSource := DataSource;
    eddata_movimento.SetParentComponent(Self);
    eddata_movimento.Name := 'eddata_movimento';
    eddata_movimento.Left := 1005;
    eddata_movimento.Top := 130;
    eddata_movimento.Width := 100;
    eddata_movimento.Height := 21;
    eddata_movimento.Enabled := False;
    eddata_movimento.HeightPercent := 100.000000000000000000;
    eddata_movimento.TabOrder := 57;
    eddata_movimento.Text := 'eddata_movimento';
    eddata_movimento.WidthPercent := 100.000000000000000000;
    eddata_movimento.DataField := 'data_movimento';
    eddata_movimento.DataSource := DataSource;
    edchave_acesso_terceiros.SetParentComponent(Self);
    edchave_acesso_terceiros.Name := 'edchave_acesso_terceiros';
    edchave_acesso_terceiros.Left := 1005;
    edchave_acesso_terceiros.Top := 183;
    edchave_acesso_terceiros.Width := 100;
    edchave_acesso_terceiros.Height := 21;
    edchave_acesso_terceiros.Enabled := False;
    edchave_acesso_terceiros.HeightPercent := 100.000000000000000000;
    edchave_acesso_terceiros.TabOrder := 63;
    edchave_acesso_terceiros.Text := 'edchave_acesso_terceiros';
    edchave_acesso_terceiros.WidthPercent := 100.000000000000000000;
    edchave_acesso_terceiros.DataField := 'chave_acesso_terceiros';
    edchave_acesso_terceiros.DataSource := DataSource;
    edvalor_icms_desonerado.SetParentComponent(Self);
    edvalor_icms_desonerado.Name := 'edvalor_icms_desonerado';
    edvalor_icms_desonerado.Left := 1006;
    edvalor_icms_desonerado.Top := 237;
    edvalor_icms_desonerado.Width := 100;
    edvalor_icms_desonerado.Height := 21;
    edvalor_icms_desonerado.Enabled := False;
    edvalor_icms_desonerado.HeightPercent := 100.000000000000000000;
    edvalor_icms_desonerado.TabOrder := 67;
    edvalor_icms_desonerado.Text := 'edvalor_icms_desonerado';
    edvalor_icms_desonerado.WidthPercent := 100.000000000000000000;
    edvalor_icms_desonerado.DataField := 'valor_icms_desonerado';
    edvalor_icms_desonerado.DataSource := DataSource;
    edvalor_ipi_devolucao.SetParentComponent(Self);
    edvalor_ipi_devolucao.Name := 'edvalor_ipi_devolucao';
    edvalor_ipi_devolucao.Left := 1005;
    edvalor_ipi_devolucao.Top := 264;
    edvalor_ipi_devolucao.Width := 100;
    edvalor_ipi_devolucao.Height := 21;
    edvalor_ipi_devolucao.Enabled := False;
    edvalor_ipi_devolucao.HeightPercent := 100.000000000000000000;
    edvalor_ipi_devolucao.TabOrder := 68;
    edvalor_ipi_devolucao.Text := 'edvalor_ipi_devolucao';
    edvalor_ipi_devolucao.WidthPercent := 100.000000000000000000;
    edvalor_ipi_devolucao.DataField := 'valor_ipi_devolucao';
    edvalor_ipi_devolucao.DataSource := DataSource;
    edvalor_fcp_st.SetParentComponent(Self);
    edvalor_fcp_st.Name := 'edvalor_fcp_st';
    edvalor_fcp_st.Left := 513;
    edvalor_fcp_st.Top := 342;
    edvalor_fcp_st.Width := 100;
    edvalor_fcp_st.Height := 21;
    edvalor_fcp_st.Enabled := False;
    edvalor_fcp_st.HeightPercent := 100.000000000000000000;
    edvalor_fcp_st.TabOrder := 70;
    edvalor_fcp_st.Text := 'edvalor_fcp_st';
    edvalor_fcp_st.WidthPercent := 100.000000000000000000;
    edvalor_fcp_st.DataField := 'valor_fcp_st';
    edvalor_fcp_st.DataSource := DataSource;
    edvalor_retido_pis.SetParentComponent(Self);
    edvalor_retido_pis.Name := 'edvalor_retido_pis';
    edvalor_retido_pis.Left := 104;
    edvalor_retido_pis.Top := 288;
    edvalor_retido_pis.Width := 100;
    edvalor_retido_pis.Height := 21;
    edvalor_retido_pis.Enabled := False;
    edvalor_retido_pis.HeightPercent := 100.000000000000000000;
    edvalor_retido_pis.TabOrder := 71;
    edvalor_retido_pis.Text := 'edvalor_retido_pis';
    edvalor_retido_pis.WidthPercent := 100.000000000000000000;
    edvalor_retido_pis.DataField := 'valor_retido_pis';
    edvalor_retido_pis.DataSource := DataSource;
    edvalor_retido_cofins.SetParentComponent(Self);
    edvalor_retido_cofins.Name := 'edvalor_retido_cofins';
    edvalor_retido_cofins.Left := 104;
    edvalor_retido_cofins.Top := 315;
    edvalor_retido_cofins.Width := 100;
    edvalor_retido_cofins.Height := 21;
    edvalor_retido_cofins.Enabled := False;
    edvalor_retido_cofins.HeightPercent := 100.000000000000000000;
    edvalor_retido_cofins.TabOrder := 72;
    edvalor_retido_cofins.Text := 'edvalor_retido_cofins';
    edvalor_retido_cofins.WidthPercent := 100.000000000000000000;
    edvalor_retido_cofins.DataField := 'valor_retido_cofins';
    edvalor_retido_cofins.DataSource := DataSource;
    edvalor_retido_csll.SetParentComponent(Self);
    edvalor_retido_csll.Name := 'edvalor_retido_csll';
    edvalor_retido_csll.Left := 104;
    edvalor_retido_csll.Top := 342;
    edvalor_retido_csll.Width := 100;
    edvalor_retido_csll.Height := 21;
    edvalor_retido_csll.Enabled := False;
    edvalor_retido_csll.HeightPercent := 100.000000000000000000;
    edvalor_retido_csll.TabOrder := 73;
    edvalor_retido_csll.Text := 'edvalor_retido_csll';
    edvalor_retido_csll.WidthPercent := 100.000000000000000000;
    edvalor_retido_csll.DataField := 'valor_retido_csll';
    edvalor_retido_csll.DataSource := DataSource;
    edvalor_base_calculo_irrf.SetParentComponent(Self);
    edvalor_base_calculo_irrf.Name := 'edvalor_base_calculo_irrf';
    edvalor_base_calculo_irrf.Left := 318;
    edvalor_base_calculo_irrf.Top := 288;
    edvalor_base_calculo_irrf.Width := 100;
    edvalor_base_calculo_irrf.Height := 21;
    edvalor_base_calculo_irrf.Enabled := False;
    edvalor_base_calculo_irrf.HeightPercent := 100.000000000000000000;
    edvalor_base_calculo_irrf.TabOrder := 74;
    edvalor_base_calculo_irrf.Text := 'edvalor_base_calculo_irrf';
    edvalor_base_calculo_irrf.WidthPercent := 100.000000000000000000;
    edvalor_base_calculo_irrf.DataField := 'valor_base_calculo_irrf';
    edvalor_base_calculo_irrf.DataSource := DataSource;
    edaliquota_irrf.SetParentComponent(Self);
    edaliquota_irrf.Name := 'edaliquota_irrf';
    edaliquota_irrf.Left := 318;
    edaliquota_irrf.Top := 315;
    edaliquota_irrf.Width := 100;
    edaliquota_irrf.Height := 21;
    edaliquota_irrf.Enabled := False;
    edaliquota_irrf.HeightPercent := 100.000000000000000000;
    edaliquota_irrf.TabOrder := 75;
    edaliquota_irrf.Text := 'edaliquota_irrf';
    edaliquota_irrf.WidthPercent := 100.000000000000000000;
    edaliquota_irrf.DataField := 'aliquota_irrf';
    edaliquota_irrf.DataSource := DataSource;
    edvalor_retido_irrf.SetParentComponent(Self);
    edvalor_retido_irrf.Name := 'edvalor_retido_irrf';
    edvalor_retido_irrf.Left := 318;
    edvalor_retido_irrf.Top := 342;
    edvalor_retido_irrf.Width := 100;
    edvalor_retido_irrf.Height := 21;
    edvalor_retido_irrf.Enabled := False;
    edvalor_retido_irrf.HeightPercent := 100.000000000000000000;
    edvalor_retido_irrf.TabOrder := 76;
    edvalor_retido_irrf.Text := 'edvalor_retido_irrf';
    edvalor_retido_irrf.WidthPercent := 100.000000000000000000;
    edvalor_retido_irrf.DataField := 'valor_retido_irrf';
    edvalor_retido_irrf.DataSource := DataSource;
    edvalor_base_calculo_previdencia_social.SetParentComponent(Self);
    edvalor_base_calculo_previdencia_social.Name := 'edvalor_base_calculo_previdencia_social';
    edvalor_base_calculo_previdencia_social.Left := 766;
    edvalor_base_calculo_previdencia_social.Top := 315;
    edvalor_base_calculo_previdencia_social.Width := 100;
    edvalor_base_calculo_previdencia_social.Height := 21;
    edvalor_base_calculo_previdencia_social.Enabled := False;
    edvalor_base_calculo_previdencia_social.HeightPercent := 100.000000000000000000;
    edvalor_base_calculo_previdencia_social.TabOrder := 77;
    edvalor_base_calculo_previdencia_social.Text := 'edvalor_base_calculo_previdencia_social';
    edvalor_base_calculo_previdencia_social.WidthPercent := 100.000000000000000000;
    edvalor_base_calculo_previdencia_social.DataField := 'valor_base_calculo_previdencia_social';
    edvalor_base_calculo_previdencia_social.DataSource := DataSource;
    edaliquota_previdencia_social.SetParentComponent(Self);
    edaliquota_previdencia_social.Name := 'edaliquota_previdencia_social';
    edaliquota_previdencia_social.Left := 513;
    edaliquota_previdencia_social.Top := 288;
    edaliquota_previdencia_social.Width := 100;
    edaliquota_previdencia_social.Height := 21;
    edaliquota_previdencia_social.Enabled := False;
    edaliquota_previdencia_social.HeightPercent := 100.000000000000000000;
    edaliquota_previdencia_social.TabOrder := 78;
    edaliquota_previdencia_social.Text := 'edaliquota_previdencia_social';
    edaliquota_previdencia_social.WidthPercent := 100.000000000000000000;
    edaliquota_previdencia_social.DataField := 'aliquota_previdencia_social';
    edaliquota_previdencia_social.DataSource := DataSource;
    edvalor_previdencia_social.SetParentComponent(Self);
    edvalor_previdencia_social.Name := 'edvalor_previdencia_social';
    edvalor_previdencia_social.Left := 513;
    edvalor_previdencia_social.Top := 315;
    edvalor_previdencia_social.Width := 100;
    edvalor_previdencia_social.Height := 21;
    edvalor_previdencia_social.Enabled := False;
    edvalor_previdencia_social.HeightPercent := 100.000000000000000000;
    edvalor_previdencia_social.TabOrder := 79;
    edvalor_previdencia_social.Text := 'edvalor_previdencia_social';
    edvalor_previdencia_social.WidthPercent := 100.000000000000000000;
    edvalor_previdencia_social.DataField := 'valor_previdencia_social';
    edvalor_previdencia_social.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 317;
    edcodigo_interno.Top := 22;
    edcodigo_interno.Width := 100;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 81;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 317;
    edinclusao.Top := 76;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 83;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 317;
    edalteracao.Top := 103;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 84;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 317;
    edexclusao.Top := 130;
    edexclusao.Width := 100;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 85;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 317;
    cbxexcluido.Top := 49;
    cbxexcluido.Width := 100;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxipi_compoe_base_icms.SetParentComponent(Self);
    cbxipi_compoe_base_icms.Name := 'cbxipi_compoe_base_icms';
    cbxipi_compoe_base_icms.Left := 766;
    cbxipi_compoe_base_icms.Top := 237;
    cbxipi_compoe_base_icms.Width := 100;
    cbxipi_compoe_base_icms.Height := 22;
    cbxipi_compoe_base_icms.Caption := 'cbxipi_compoe_base_icms';
    cbxipi_compoe_base_icms.ChildOrder := 33;
    cbxipi_compoe_base_icms.Enabled := False;
    cbxipi_compoe_base_icms.HeightPercent := 100.000000000000000000;
    cbxipi_compoe_base_icms.WidthPercent := 100.000000000000000000;
    cbxipi_compoe_base_icms.DataField := 'ipi_compoe_base_icms';
    cbxipi_compoe_base_icms.DataSource := DataSource;
    cbxfrete_compoe_base_icms.SetParentComponent(Self);
    cbxfrete_compoe_base_icms.Name := 'cbxfrete_compoe_base_icms';
    cbxfrete_compoe_base_icms.Left := 766;
    cbxfrete_compoe_base_icms.Top := 265;
    cbxfrete_compoe_base_icms.Width := 100;
    cbxfrete_compoe_base_icms.Height := 22;
    cbxfrete_compoe_base_icms.Caption := 'cbxfrete_compoe_base_icms';
    cbxfrete_compoe_base_icms.ChildOrder := 33;
    cbxfrete_compoe_base_icms.Enabled := False;
    cbxfrete_compoe_base_icms.HeightPercent := 100.000000000000000000;
    cbxfrete_compoe_base_icms.WidthPercent := 100.000000000000000000;
    cbxfrete_compoe_base_icms.DataField := 'frete_compoe_base_icms';
    cbxfrete_compoe_base_icms.DataSource := DataSource;
    cbxseguro_compoe_base_icms.SetParentComponent(Self);
    cbxseguro_compoe_base_icms.Name := 'cbxseguro_compoe_base_icms';
    cbxseguro_compoe_base_icms.Left := 1006;
    cbxseguro_compoe_base_icms.Top := 22;
    cbxseguro_compoe_base_icms.Width := 100;
    cbxseguro_compoe_base_icms.Height := 22;
    cbxseguro_compoe_base_icms.Caption := 'cbxseguro_compoe_base_icms';
    cbxseguro_compoe_base_icms.ChildOrder := 33;
    cbxseguro_compoe_base_icms.Enabled := False;
    cbxseguro_compoe_base_icms.HeightPercent := 100.000000000000000000;
    cbxseguro_compoe_base_icms.WidthPercent := 100.000000000000000000;
    cbxseguro_compoe_base_icms.DataField := 'seguro_compoe_base_icms';
    cbxseguro_compoe_base_icms.DataSource := DataSource;
    cbxoutras_compoe_base_icms.SetParentComponent(Self);
    cbxoutras_compoe_base_icms.Name := 'cbxoutras_compoe_base_icms';
    cbxoutras_compoe_base_icms.Left := 1005;
    cbxoutras_compoe_base_icms.Top := 49;
    cbxoutras_compoe_base_icms.Width := 100;
    cbxoutras_compoe_base_icms.Height := 22;
    cbxoutras_compoe_base_icms.Caption := 'cbxoutras_compoe_base_icms';
    cbxoutras_compoe_base_icms.ChildOrder := 33;
    cbxoutras_compoe_base_icms.Enabled := False;
    cbxoutras_compoe_base_icms.HeightPercent := 100.000000000000000000;
    cbxoutras_compoe_base_icms.WidthPercent := 100.000000000000000000;
    cbxoutras_compoe_base_icms.DataField := 'outras_compoe_base_icms';
    cbxoutras_compoe_base_icms.DataSource := DataSource;
    cbxexcluiu_icms_base_pis_cofins.SetParentComponent(Self);
    cbxexcluiu_icms_base_pis_cofins.Name := 'cbxexcluiu_icms_base_pis_cofins';
    cbxexcluiu_icms_base_pis_cofins.Left := 766;
    cbxexcluiu_icms_base_pis_cofins.Top := 288;
    cbxexcluiu_icms_base_pis_cofins.Width := 100;
    cbxexcluiu_icms_base_pis_cofins.Height := 22;
    cbxexcluiu_icms_base_pis_cofins.Caption := 'cbxexcluiu_icms_base_pis_cofins';
    cbxexcluiu_icms_base_pis_cofins.ChildOrder := 33;
    cbxexcluiu_icms_base_pis_cofins.Enabled := False;
    cbxexcluiu_icms_base_pis_cofins.HeightPercent := 100.000000000000000000;
    cbxexcluiu_icms_base_pis_cofins.WidthPercent := 100.000000000000000000;
    cbxexcluiu_icms_base_pis_cofins.DataField := 'excluiu_icms_base_pis_cofins';
    cbxexcluiu_icms_base_pis_cofins.DataSource := DataSource;
    cbxexcluiu_fcp_base_pis_cofins.SetParentComponent(Self);
    cbxexcluiu_fcp_base_pis_cofins.Name := 'cbxexcluiu_fcp_base_pis_cofins';
    cbxexcluiu_fcp_base_pis_cofins.Left := 766;
    cbxexcluiu_fcp_base_pis_cofins.Top := 342;
    cbxexcluiu_fcp_base_pis_cofins.Width := 100;
    cbxexcluiu_fcp_base_pis_cofins.Height := 22;
    cbxexcluiu_fcp_base_pis_cofins.Caption := 'cbxexcluiu_fcp_base_pis_cofins';
    cbxexcluiu_fcp_base_pis_cofins.ChildOrder := 33;
    cbxexcluiu_fcp_base_pis_cofins.Enabled := False;
    cbxexcluiu_fcp_base_pis_cofins.HeightPercent := 100.000000000000000000;
    cbxexcluiu_fcp_base_pis_cofins.WidthPercent := 100.000000000000000000;
    cbxexcluiu_fcp_base_pis_cofins.DataField := 'excluiu_fcp_base_pis_cofins';
    cbxexcluiu_fcp_base_pis_cofins.DataSource := DataSource;
    cbxsimples_faturamento.SetParentComponent(Self);
    cbxsimples_faturamento.Name := 'cbxsimples_faturamento';
    cbxsimples_faturamento.Left := 1005;
    cbxsimples_faturamento.Top := 210;
    cbxsimples_faturamento.Width := 100;
    cbxsimples_faturamento.Height := 22;
    cbxsimples_faturamento.Caption := 'cbxsimples_faturamento';
    cbxsimples_faturamento.ChildOrder := 33;
    cbxsimples_faturamento.Enabled := False;
    cbxsimples_faturamento.HeightPercent := 100.000000000000000000;
    cbxsimples_faturamento.WidthPercent := 100.000000000000000000;
    cbxsimples_faturamento.DataField := 'simples_faturamento';
    cbxsimples_faturamento.DataSource := DataSource;
    cbxemissao_terceiros.SetParentComponent(Self);
    cbxemissao_terceiros.Name := 'cbxemissao_terceiros';
    cbxemissao_terceiros.Left := 1005;
    cbxemissao_terceiros.Top := 156;
    cbxemissao_terceiros.Width := 100;
    cbxemissao_terceiros.Height := 22;
    cbxemissao_terceiros.Caption := 'cbxemissao_terceiros';
    cbxemissao_terceiros.ChildOrder := 33;
    cbxemissao_terceiros.Enabled := False;
    cbxemissao_terceiros.HeightPercent := 100.000000000000000000;
    cbxemissao_terceiros.WidthPercent := 100.000000000000000000;
    cbxemissao_terceiros.DataField := 'emissao_terceiros';
    cbxemissao_terceiros.DataSource := DataSource;
    pnlFormDados.SetParentComponent(Self);
    pnlFormDados.Name := 'pnlFormDados';
    pnlFormDados.Left := 8;
    pnlFormDados.Top := 2;
    pnlFormDados.Width := 1102;
    pnlFormDados.Height := 17;
    pnlFormDados.Caption := 'Espa'#231'o Form Dados';
    pnlFormDados.ChildOrder := 23;
    pnlFormDados.Color := clInfoText;
    pnlFormDados.Font.Charset := DEFAULT_CHARSET;
    pnlFormDados.Font.Color := clWhite;
    pnlFormDados.Font.Height := -11;
    pnlFormDados.Font.Name := 'Tahoma';
    pnlFormDados.Font.Style := [fsBold];
    pnlFormDados.ParentFont := False;
    pnlFormDados.TabOrder := 63;
    pnlFormDados.Visible := False;
    tblItens.SetParentComponent(Self);
    tblItens.Name := 'tblItens';
    tblItens.Left := 8;
    tblItens.Top := 451;
    tblItens.Width := 225;
    tblItens.Height := 102;
    tblItens.ElementClassName := 'table-responsive';
    tblItens.BorderColor := clSilver;
    tblItens.ChildOrder := 28;
    tblItens.ColHeader := False;
    tblItens.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblItens, Self, 'OnGetCellChildren', 'tblItensGetCellChildren');
    SetEvent(tblItens, Self, 'OnGetCellClass', 'tblItensGetCellClass');
    tblItens.Columns.Clear;
    with tblItens.Columns.Add do
    begin
      DataField := 'item';
      Title := 'item';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'prod.codigo_interno';
      Title := 'C'#243'd. Produto';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'prod.nome';
      Title := 'Produto';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'unidade.sigla';
      Title := 'Unidade';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'produto_preco';
      Title := 'Pre'#231'o';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'quantidade';
      Title := 'quantidade';
    end;
    with tblItens.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Total';
    end;
    tblItens.DataSource := dtsItens;
    cbPageSizeItens.SetParentComponent(Self);
    cbPageSizeItens.Name := 'cbPageSizeItens';
    cbPageSizeItens.Left := 8;
    cbPageSizeItens.Top := 424;
    cbPageSizeItens.Width := 81;
    cbPageSizeItens.Height := 21;
    cbPageSizeItens.HeightPercent := 100.000000000000000000;
    cbPageSizeItens.TabOrder := 2;
    cbPageSizeItens.Text := '10';
    cbPageSizeItens.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeItens, Self, 'OnChange', 'cbPageSizeItensChange');
    cbPageSizeItens.ItemIndex := 0;
    cbPageSizeItens.Items.BeginUpdate;
    try
      cbPageSizeItens.Items.Clear;
      cbPageSizeItens.Items.Add('10');
      cbPageSizeItens.Items.Add('25');
      cbPageSizeItens.Items.Add('50');
      cbPageSizeItens.Items.Add('100');
    finally
      cbPageSizeItens.Items.EndUpdate;
    end;
    edSearchItens.SetParentComponent(Self);
    edSearchItens.Name := 'edSearchItens';
    edSearchItens.Left := 95;
    edSearchItens.Top := 424;
    edSearchItens.Width := 54;
    edSearchItens.Height := 21;
    edSearchItens.ChildOrder := 30;
    edSearchItens.HeightPercent := 100.000000000000000000;
    edSearchItens.TabOrder := 3;
    edSearchItens.WidthPercent := 100.000000000000000000;
    SetEvent(edSearchItens, Self, 'OnKeyDown', 'edSearchItensKeyDown');
    SetEvent(edSearchItens, Self, 'OnKeyUp', 'edSearchItensKeyUp');
    pnlItensPromocao.SetParentComponent(Self);
    pnlItensPromocao.Name := 'pnlItensPromocao';
    pnlItensPromocao.Left := 8;
    pnlItensPromocao.Top := 400;
    pnlItensPromocao.Width := 225;
    pnlItensPromocao.Height := 17;
    pnlItensPromocao.Caption := 'Espa'#231'o tabela Itens';
    pnlItensPromocao.ChildOrder := 23;
    pnlItensPromocao.Color := clInfoText;
    pnlItensPromocao.Font.Charset := DEFAULT_CHARSET;
    pnlItensPromocao.Font.Color := clWhite;
    pnlItensPromocao.Font.Height := -11;
    pnlItensPromocao.Font.Name := 'Tahoma';
    pnlItensPromocao.Font.Style := [fsBold];
    pnlItensPromocao.ParentFont := False;
    pnlItensPromocao.TabOrder := 67;
    pnlItensPromocao.Visible := False;
    btnItensTab.SetParentComponent(Self);
    btnItensTab.Name := 'btnItensTab';
    btnItensTab.Left := 155;
    btnItensTab.Top := 423;
    btnItensTab.Width := 78;
    btnItensTab.Height := 25;
    btnItensTab.Caption := 'Itens';
    btnItensTab.ChildOrder := 34;
    btnItensTab.HeightPercent := 100.000000000000000000;
    btnItensTab.TabOrder := 1;
    btnItensTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnItensTab, Self, 'OnClick', 'btnItensTabClick');
    lcPaginatorItens.SetParentComponent(Self);
    lcPaginatorItens.Name := 'lcPaginatorItens';
    lcPaginatorItens.Left := 112;
    lcPaginatorItens.Top := 559;
    lcPaginatorItens.Width := 121;
    lcPaginatorItens.Height := 13;
    lcPaginatorItens.HeightPercent := 100.000000000000000000;
    lcPaginatorItens.WidthPercent := 100.000000000000000000;
    lcPaginatorItens.ChildOrder := 132;
    lcPaginatorItens.DefaultItemClassName := 'page-item';
    lcPaginatorItens.DefaultItemLinkClassName := 'page-link';
    lcPaginatorItens.ElementListClassName := 'pagination';
    lcPaginatorItens.Items.Clear;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorItens.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorItens.Style := lsPagination;
    pnlTabelaAReceber.SetParentComponent(Self);
    pnlTabelaAReceber.Name := 'pnlTabelaAReceber';
    pnlTabelaAReceber.Left := 243;
    pnlTabelaAReceber.Top := 400;
    pnlTabelaAReceber.Width := 225;
    pnlTabelaAReceber.Height := 17;
    pnlTabelaAReceber.Caption := 'Espa'#231'o AReceber';
    pnlTabelaAReceber.ChildOrder := 23;
    pnlTabelaAReceber.Color := clInfoText;
    pnlTabelaAReceber.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaAReceber.Font.Color := clWhite;
    pnlTabelaAReceber.Font.Height := -11;
    pnlTabelaAReceber.Font.Name := 'Tahoma';
    pnlTabelaAReceber.Font.Style := [fsBold];
    pnlTabelaAReceber.ParentFont := False;
    pnlTabelaAReceber.TabOrder := 70;
    pnlTabelaAReceber.Visible := False;
    tblAReceber.SetParentComponent(Self);
    tblAReceber.Name := 'tblAReceber';
    tblAReceber.Left := 243;
    tblAReceber.Top := 451;
    tblAReceber.Width := 225;
    tblAReceber.Height := 102;
    tblAReceber.ElementClassName := 'table-responsive';
    tblAReceber.BorderColor := clSilver;
    tblAReceber.ChildOrder := 82;
    tblAReceber.ColHeader := False;
    tblAReceber.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblAReceber, Self, 'OnGetCellData', 'tblAReceberGetCellData');
    SetEvent(tblAReceber, Self, 'OnGetCellClass', 'tblAReceberGetCellClass');
    tblAReceber.Columns.Clear;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'Doc./Parcela';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'Emiss'#227'o';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'vencimento';
      Title := 'Vencimento';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_saldo_pendente';
      Title := 'Saldo Pendente';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_pago';
      Title := 'Valor Pago';
    end;
    with tblAReceber.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Valor Total';
    end;
    tblAReceber.DataSource := dtsAReceber;
    lcPaginatorAReceber.SetParentComponent(Self);
    lcPaginatorAReceber.Name := 'lcPaginatorAReceber';
    lcPaginatorAReceber.Left := 366;
    lcPaginatorAReceber.Top := 557;
    lcPaginatorAReceber.Width := 102;
    lcPaginatorAReceber.Height := 15;
    lcPaginatorAReceber.HeightPercent := 100.000000000000000000;
    lcPaginatorAReceber.WidthPercent := 100.000000000000000000;
    lcPaginatorAReceber.ChildOrder := 81;
    lcPaginatorAReceber.DefaultItemClassName := 'page-item';
    lcPaginatorAReceber.DefaultItemLinkClassName := 'page-link';
    lcPaginatorAReceber.ElementListClassName := 'pagination';
    lcPaginatorAReceber.Items.Clear;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorAReceber.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorAReceber.Style := lsPagination;
    tblRecebimentos.SetParentComponent(Self);
    tblRecebimentos.Name := 'tblRecebimentos';
    tblRecebimentos.Left := 485;
    tblRecebimentos.Top := 451;
    tblRecebimentos.Width := 225;
    tblRecebimentos.Height := 97;
    tblRecebimentos.ElementClassName := 'table-responsive';
    tblRecebimentos.BorderColor := clSilver;
    tblRecebimentos.ChildOrder := 82;
    tblRecebimentos.ColHeader := False;
    tblRecebimentos.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblRecebimentos, Self, 'OnGetCellClass', 'tblRecebimentosGetCellClass');
    tblRecebimentos.Columns.Clear;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'areceber.documento';
      Title := 'Doc./Parcela';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'modalidade.nome';
      Title := 'Modalidade';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'data_recebimento';
      Title := 'Data Recebimento';
    end;
    with tblRecebimentos.Columns.Add do
    begin
      DataField := 'valor_bruto_recebido';
      Title := 'Valor';
    end;
    tblRecebimentos.DataSource := dtsRecebimentos;
    pnlTabelaPagamentos.SetParentComponent(Self);
    pnlTabelaPagamentos.Name := 'pnlTabelaPagamentos';
    pnlTabelaPagamentos.Left := 485;
    pnlTabelaPagamentos.Top := 400;
    pnlTabelaPagamentos.Width := 225;
    pnlTabelaPagamentos.Height := 17;
    pnlTabelaPagamentos.Caption := 'Espa'#231'o Pagamentos';
    pnlTabelaPagamentos.ChildOrder := 23;
    pnlTabelaPagamentos.Color := clInfoText;
    pnlTabelaPagamentos.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaPagamentos.Font.Color := clWhite;
    pnlTabelaPagamentos.Font.Height := -11;
    pnlTabelaPagamentos.Font.Name := 'Tahoma';
    pnlTabelaPagamentos.Font.Style := [fsBold];
    pnlTabelaPagamentos.ParentFont := False;
    pnlTabelaPagamentos.TabOrder := 74;
    pnlTabelaPagamentos.Visible := False;
    btnFinanceiroTab.SetParentComponent(Self);
    btnFinanceiroTab.Name := 'btnFinanceiroTab';
    btnFinanceiroTab.Left := 243;
    btnFinanceiroTab.Top := 423;
    btnFinanceiroTab.Width := 78;
    btnFinanceiroTab.Height := 25;
    btnFinanceiroTab.Caption := 'Financeiro';
    btnFinanceiroTab.ChildOrder := 34;
    btnFinanceiroTab.HeightPercent := 100.000000000000000000;
    btnFinanceiroTab.TabOrder := 1;
    btnFinanceiroTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnFinanceiroTab, Self, 'OnClick', 'btnFinanceiroTabClick');
    btnRecebimentosTab.SetParentComponent(Self);
    btnRecebimentosTab.Name := 'btnRecebimentosTab';
    btnRecebimentosTab.Left := 485;
    btnRecebimentosTab.Top := 423;
    btnRecebimentosTab.Width := 78;
    btnRecebimentosTab.Height := 25;
    btnRecebimentosTab.Caption := 'Recebimentos';
    btnRecebimentosTab.ChildOrder := 34;
    btnRecebimentosTab.HeightPercent := 100.000000000000000000;
    btnRecebimentosTab.TabOrder := 1;
    btnRecebimentosTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnRecebimentosTab, Self, 'OnClick', 'btnRecebimentosTabClick');
    lcPaginatorRecebimentos.SetParentComponent(Self);
    lcPaginatorRecebimentos.Name := 'lcPaginatorRecebimentos';
    lcPaginatorRecebimentos.Left := 608;
    lcPaginatorRecebimentos.Top := 554;
    lcPaginatorRecebimentos.Width := 102;
    lcPaginatorRecebimentos.Height := 15;
    lcPaginatorRecebimentos.HeightPercent := 100.000000000000000000;
    lcPaginatorRecebimentos.WidthPercent := 100.000000000000000000;
    lcPaginatorRecebimentos.ChildOrder := 81;
    lcPaginatorRecebimentos.DefaultItemClassName := 'page-item';
    lcPaginatorRecebimentos.DefaultItemLinkClassName := 'page-link';
    lcPaginatorRecebimentos.ElementListClassName := 'pagination';
    lcPaginatorRecebimentos.Items.Clear;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorRecebimentos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorRecebimentos.Style := lsPagination;
    pnlFormNfe.SetParentComponent(Self);
    pnlFormNfe.Name := 'pnlFormNfe';
    pnlFormNfe.Left := 737;
    pnlFormNfe.Top := 400;
    pnlFormNfe.Width := 225;
    pnlFormNfe.Height := 17;
    pnlFormNfe.Caption := 'Espa'#231'o NFe';
    pnlFormNfe.ChildOrder := 23;
    pnlFormNfe.Color := clInfoText;
    pnlFormNfe.Font.Charset := DEFAULT_CHARSET;
    pnlFormNfe.Font.Color := clWhite;
    pnlFormNfe.Font.Height := -11;
    pnlFormNfe.Font.Name := 'Tahoma';
    pnlFormNfe.Font.Style := [fsBold];
    pnlFormNfe.ParentFont := False;
    pnlFormNfe.TabOrder := 78;
    pnlFormNfe.Visible := False;
    edchave_acesso.SetParentComponent(Self);
    edchave_acesso.Name := 'edchave_acesso';
    edchave_acesso.Left := 832;
    edchave_acesso.Top := 419;
    edchave_acesso.Width := 100;
    edchave_acesso.Height := 21;
    edchave_acesso.ChildOrder := 145;
    edchave_acesso.Enabled := False;
    edchave_acesso.HeightPercent := 100.000000000000000000;
    edchave_acesso.TabOrder := 28;
    edchave_acesso.Text := 'edchave_acesso';
    edchave_acesso.WidthPercent := 100.000000000000000000;
    edchave_acesso.DataField := 'nfe.chave_acesso';
    edchave_acesso.DataSource := DataSource;
    ednfe_transmissao.SetParentComponent(Self);
    ednfe_transmissao.Name := 'ednfe_transmissao';
    ednfe_transmissao.Left := 832;
    ednfe_transmissao.Top := 445;
    ednfe_transmissao.Width := 100;
    ednfe_transmissao.Height := 21;
    ednfe_transmissao.ChildOrder := 145;
    ednfe_transmissao.Enabled := False;
    ednfe_transmissao.HeightPercent := 100.000000000000000000;
    ednfe_transmissao.TabOrder := 28;
    ednfe_transmissao.Text := 'ednfe_transmissao';
    ednfe_transmissao.WidthPercent := 100.000000000000000000;
    ednfe_transmissao.DataField := 'nfe.nfe_transmissao';
    ednfe_transmissao.DataSource := DataSource;
    btnCopiarChaveAcesso.SetParentComponent(Self);
    btnCopiarChaveAcesso.Name := 'btnCopiarChaveAcesso';
    btnCopiarChaveAcesso.Left := 932;
    btnCopiarChaveAcesso.Top := 419;
    btnCopiarChaveAcesso.Width := 30;
    btnCopiarChaveAcesso.Height := 21;
    btnCopiarChaveAcesso.ChildOrder := 22;
    btnCopiarChaveAcesso.HeightPercent := 100.000000000000000000;
    btnCopiarChaveAcesso.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarChaveAcesso, Self, 'OnClick', 'btnCopiarChaveAcessoClick');
    btnNfeTab.SetParentComponent(Self);
    btnNfeTab.Name := 'btnNfeTab';
    btnNfeTab.Left := 736;
    btnNfeTab.Top := 471;
    btnNfeTab.Width := 78;
    btnNfeTab.Height := 25;
    btnNfeTab.Caption := 'NFe';
    btnNfeTab.ChildOrder := 34;
    btnNfeTab.HeightPercent := 100.000000000000000000;
    btnNfeTab.TabOrder := 1;
    btnNfeTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnNfeTab, Self, 'OnClick', 'btnNfeTabClick');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := VendasDataset;
    DataSource.Left := 1048;
    DataSource.Top := 304;
    VendasDataset.SetParentComponent(Self);
    VendasDataset.Name := 'VendasDataset';
    VendasDataset.AfterApplyUpdates := VendasDatasetAfterApplyUpdates;
    VendasDataset.EntitySetName := 'Vendas';
    VendasDataset.Connection := DMConnection.ApiConnection;
    VendasDataset.Left := 992;
    VendasDataset.Top := 304;
    VendasDatasetid.SetParentComponent(VendasDataset);
    VendasDatasetid.Name := 'VendasDatasetid';
    VendasDatasetid.FieldName := 'id';
    VendasDatasetid.Required := True;
    VendasDatasetaliado_id.SetParentComponent(VendasDataset);
    VendasDatasetaliado_id.Name := 'VendasDatasetaliado_id';
    VendasDatasetaliado_id.FieldName := 'aliado_id';
    VendasDatasetaliado_id.Required := True;
    VendasDatasetdata_base_id.SetParentComponent(VendasDataset);
    VendasDatasetdata_base_id.Name := 'VendasDatasetdata_base_id';
    VendasDatasetdata_base_id.FieldName := 'data_base_id';
    VendasDatasetdata_base_id.Required := True;
    VendasDatasetcliente_id.SetParentComponent(VendasDataset);
    VendasDatasetcliente_id.Name := 'VendasDatasetcliente_id';
    VendasDatasetcliente_id.FieldName := 'cliente_id';
    VendasDatasetcliente_id.Required := True;
    VendasDatasetfuncionario_id.SetParentComponent(VendasDataset);
    VendasDatasetfuncionario_id.Name := 'VendasDatasetfuncionario_id';
    VendasDatasetfuncionario_id.FieldName := 'funcionario_id';
    VendasDatasetcaixa.SetParentComponent(VendasDataset);
    VendasDatasetcaixa.Name := 'VendasDatasetcaixa';
    VendasDatasetcaixa.FieldName := 'caixa';
    VendasDatasetcfop_cfop.SetParentComponent(VendasDataset);
    VendasDatasetcfop_cfop.Name := 'VendasDatasetcfop_cfop';
    VendasDatasetcfop_cfop.FieldName := 'cfop_cfop';
    VendasDatasetcfop_cfop.Required := True;
    SetEvent(VendasDatasetcfop_cfop, Self, 'OnGetText', 'VendasDatasetcfop_cfopGetText');
    VendasDatasetcfop_cfop.Size := 255;
    VendasDatasetnumero.SetParentComponent(VendasDataset);
    VendasDatasetnumero.Name := 'VendasDatasetnumero';
    VendasDatasetnumero.FieldName := 'numero';
    VendasDatasetnumero.Required := True;
    VendasDatasetnumero.Size := 255;
    VendasDatasetdoc_auxiliar.SetParentComponent(VendasDataset);
    VendasDatasetdoc_auxiliar.Name := 'VendasDatasetdoc_auxiliar';
    VendasDatasetdoc_auxiliar.FieldName := 'doc_auxiliar';
    VendasDatasetdoc_auxiliar.Size := 255;
    VendasDatasetmodelo.SetParentComponent(VendasDataset);
    VendasDatasetmodelo.Name := 'VendasDatasetmodelo';
    VendasDatasetmodelo.FieldName := 'modelo';
    VendasDatasetmodelo.Size := 255;
    VendasDatasetserie.SetParentComponent(VendasDataset);
    VendasDatasetserie.Name := 'VendasDatasetserie';
    VendasDatasetserie.FieldName := 'serie';
    VendasDatasetserie.Size := 255;
    VendasDatasetsubserie.SetParentComponent(VendasDataset);
    VendasDatasetsubserie.Name := 'VendasDatasetsubserie';
    VendasDatasetsubserie.FieldName := 'subserie';
    VendasDatasetsubserie.Size := 255;
    VendasDatasetdata_emissao.SetParentComponent(VendasDataset);
    VendasDatasetdata_emissao.Name := 'VendasDatasetdata_emissao';
    VendasDatasetdata_emissao.FieldName := 'data_emissao';
    VendasDatasetdata_emissao.Required := True;
    VendasDatasetdata_emissao.DisplayFormat := 'dd/mm/yy';
    VendasDatasetdata_saida.SetParentComponent(VendasDataset);
    VendasDatasetdata_saida.Name := 'VendasDatasetdata_saida';
    VendasDatasetdata_saida.FieldName := 'data_saida';
    VendasDatasetdata_saida.DisplayFormat := 'dd/mm/yy';
    VendasDatasetvalor_acrescimos.SetParentComponent(VendasDataset);
    VendasDatasetvalor_acrescimos.Name := 'VendasDatasetvalor_acrescimos';
    VendasDatasetvalor_acrescimos.FieldName := 'valor_acrescimos';
    VendasDatasetvalor_acrescimos.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_descontos.SetParentComponent(VendasDataset);
    VendasDatasetvalor_descontos.Name := 'VendasDatasetvalor_descontos';
    VendasDatasetvalor_descontos.FieldName := 'valor_descontos';
    VendasDatasetvalor_descontos.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_base_calculo_icms.SetParentComponent(VendasDataset);
    VendasDatasetvalor_base_calculo_icms.Name := 'VendasDatasetvalor_base_calculo_icms';
    VendasDatasetvalor_base_calculo_icms.FieldName := 'valor_base_calculo_icms';
    VendasDatasetvalor_base_calculo_icms.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_icms.SetParentComponent(VendasDataset);
    VendasDatasetvalor_icms.Name := 'VendasDatasetvalor_icms';
    VendasDatasetvalor_icms.FieldName := 'valor_icms';
    VendasDatasetvalor_icms.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_base_calculo_st.SetParentComponent(VendasDataset);
    VendasDatasetvalor_base_calculo_st.Name := 'VendasDatasetvalor_base_calculo_st';
    VendasDatasetvalor_base_calculo_st.FieldName := 'valor_base_calculo_st';
    VendasDatasetvalor_base_calculo_st.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_st.SetParentComponent(VendasDataset);
    VendasDatasetvalor_st.Name := 'VendasDatasetvalor_st';
    VendasDatasetvalor_st.FieldName := 'valor_st';
    VendasDatasetvalor_st.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_seguro.SetParentComponent(VendasDataset);
    VendasDatasetvalor_seguro.Name := 'VendasDatasetvalor_seguro';
    VendasDatasetvalor_seguro.FieldName := 'valor_seguro';
    VendasDatasetvalor_seguro.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_frete.SetParentComponent(VendasDataset);
    VendasDatasetvalor_frete.Name := 'VendasDatasetvalor_frete';
    VendasDatasetvalor_frete.FieldName := 'valor_frete';
    VendasDatasetvalor_frete.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_ipi.SetParentComponent(VendasDataset);
    VendasDatasetvalor_ipi.Name := 'VendasDatasetvalor_ipi';
    VendasDatasetvalor_ipi.FieldName := 'valor_ipi';
    VendasDatasetvalor_ipi.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_outras.SetParentComponent(VendasDataset);
    VendasDatasetvalor_outras.Name := 'VendasDatasetvalor_outras';
    VendasDatasetvalor_outras.FieldName := 'valor_outras';
    VendasDatasetvalor_outras.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_total_itens.SetParentComponent(VendasDataset);
    VendasDatasetvalor_total_itens.Name := 'VendasDatasetvalor_total_itens';
    VendasDatasetvalor_total_itens.FieldName := 'valor_total_itens';
    VendasDatasetvalor_total_itens.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_total.SetParentComponent(VendasDataset);
    VendasDatasetvalor_total.Name := 'VendasDatasetvalor_total';
    VendasDatasetvalor_total.FieldName := 'valor_total';
    VendasDatasetvalor_total.Required := True;
    VendasDatasetvalor_total.DisplayFormat := '#,##0.00';
    VendasDatasettransportadora_id.SetParentComponent(VendasDataset);
    VendasDatasettransportadora_id.Name := 'VendasDatasettransportadora_id';
    VendasDatasettransportadora_id.FieldName := 'transportadora_id';
    VendasDatasetplaca_veiculo.SetParentComponent(VendasDataset);
    VendasDatasetplaca_veiculo.Name := 'VendasDatasetplaca_veiculo';
    VendasDatasetplaca_veiculo.FieldName := 'placa_veiculo';
    VendasDatasetplaca_veiculo.Size := 255;
    VendasDatasetvolumes_quantidade.SetParentComponent(VendasDataset);
    VendasDatasetvolumes_quantidade.Name := 'VendasDatasetvolumes_quantidade';
    VendasDatasetvolumes_quantidade.FieldName := 'volumes_quantidade';
    VendasDatasetvolumes_especie.SetParentComponent(VendasDataset);
    VendasDatasetvolumes_especie.Name := 'VendasDatasetvolumes_especie';
    VendasDatasetvolumes_especie.FieldName := 'volumes_especie';
    VendasDatasetvolumes_especie.Size := 255;
    VendasDatasetvolumes_marca.SetParentComponent(VendasDataset);
    VendasDatasetvolumes_marca.Name := 'VendasDatasetvolumes_marca';
    VendasDatasetvolumes_marca.FieldName := 'volumes_marca';
    VendasDatasetvolumes_marca.Size := 255;
    VendasDatasetvolumes_peso_bruto.SetParentComponent(VendasDataset);
    VendasDatasetvolumes_peso_bruto.Name := 'VendasDatasetvolumes_peso_bruto';
    VendasDatasetvolumes_peso_bruto.FieldName := 'volumes_peso_bruto';
    VendasDatasetvolumes_peso_bruto.DisplayFormat := '#,##0.000';
    VendasDatasetvolumes_peso_liquido.SetParentComponent(VendasDataset);
    VendasDatasetvolumes_peso_liquido.Name := 'VendasDatasetvolumes_peso_liquido';
    VendasDatasetvolumes_peso_liquido.FieldName := 'volumes_peso_liquido';
    VendasDatasetvolumes_peso_liquido.DisplayFormat := '#,##0.000';
    VendasDatasetfrete_por_conta.SetParentComponent(VendasDataset);
    VendasDatasetfrete_por_conta.Name := 'VendasDatasetfrete_por_conta';
    VendasDatasetfrete_por_conta.FieldName := 'frete_por_conta';
    SetEvent(VendasDatasetfrete_por_conta, Self, 'OnGetText', 'VendasDatasetfrete_por_contaGetText');
    VendasDatasetobservacoes_credito.SetParentComponent(VendasDataset);
    VendasDatasetobservacoes_credito.Name := 'VendasDatasetobservacoes_credito';
    VendasDatasetobservacoes_credito.FieldName := 'observacoes_credito';
    VendasDatasetobservacoes_credito.Size := 255;
    VendasDatasetobservacoes.SetParentComponent(VendasDataset);
    VendasDatasetobservacoes.Name := 'VendasDatasetobservacoes';
    VendasDatasetobservacoes.FieldName := 'observacoes';
    VendasDatasetobservacoes.Size := 255;
    VendasDatasetnota_situacao.SetParentComponent(VendasDataset);
    VendasDatasetnota_situacao.Name := 'VendasDatasetnota_situacao';
    VendasDatasetnota_situacao.FieldName := 'nota_situacao';
    VendasDatasetnota_situacao.Required := True;
    VendasDatasetipi_compoe_base_icms.SetParentComponent(VendasDataset);
    VendasDatasetipi_compoe_base_icms.Name := 'VendasDatasetipi_compoe_base_icms';
    VendasDatasetipi_compoe_base_icms.FieldName := 'ipi_compoe_base_icms';
    VendasDatasetipi_compoe_base_icms.Required := True;
    VendasDatasetfrete_compoe_base_icms.SetParentComponent(VendasDataset);
    VendasDatasetfrete_compoe_base_icms.Name := 'VendasDatasetfrete_compoe_base_icms';
    VendasDatasetfrete_compoe_base_icms.FieldName := 'frete_compoe_base_icms';
    VendasDatasetfrete_compoe_base_icms.Required := True;
    VendasDatasetseguro_compoe_base_icms.SetParentComponent(VendasDataset);
    VendasDatasetseguro_compoe_base_icms.Name := 'VendasDatasetseguro_compoe_base_icms';
    VendasDatasetseguro_compoe_base_icms.FieldName := 'seguro_compoe_base_icms';
    VendasDatasetseguro_compoe_base_icms.Required := True;
    VendasDatasetoutras_compoe_base_icms.SetParentComponent(VendasDataset);
    VendasDatasetoutras_compoe_base_icms.Name := 'VendasDatasetoutras_compoe_base_icms';
    VendasDatasetoutras_compoe_base_icms.FieldName := 'outras_compoe_base_icms';
    VendasDatasetoutras_compoe_base_icms.Required := True;
    VendasDatasetvalor_isentas.SetParentComponent(VendasDataset);
    VendasDatasetvalor_isentas.Name := 'VendasDatasetvalor_isentas';
    VendasDatasetvalor_isentas.FieldName := 'valor_isentas';
    VendasDatasetvalor_isentas.DisplayFormat := '#,##0.00';
    VendasDatasetcliente_fidelidade_id.SetParentComponent(VendasDataset);
    VendasDatasetcliente_fidelidade_id.Name := 'VendasDatasetcliente_fidelidade_id';
    VendasDatasetcliente_fidelidade_id.FieldName := 'cliente_fidelidade_id';
    VendasDatasetnfe_id.SetParentComponent(VendasDataset);
    VendasDatasetnfe_id.Name := 'VendasDatasetnfe_id';
    VendasDatasetnfe_id.FieldName := 'nfe_id';
    VendasDatasetnfse_id.SetParentComponent(VendasDataset);
    VendasDatasetnfse_id.Name := 'VendasDatasetnfse_id';
    VendasDatasetnfse_id.FieldName := 'nfse_id';
    VendasDatasetosv_oss_id.SetParentComponent(VendasDataset);
    VendasDatasetosv_oss_id.Name := 'VendasDatasetosv_oss_id';
    VendasDatasetosv_oss_id.FieldName := 'osv_oss_id';
    VendasDatasetose_oss_id.SetParentComponent(VendasDataset);
    VendasDatasetose_oss_id.Name := 'VendasDatasetose_oss_id';
    VendasDatasetose_oss_id.FieldName := 'ose_oss_id';
    VendasDatasetorcamentos_id.SetParentComponent(VendasDataset);
    VendasDatasetorcamentos_id.Name := 'VendasDatasetorcamentos_id';
    VendasDatasetorcamentos_id.FieldName := 'orcamentos_id';
    VendasDatasetpet_vendas_id.SetParentComponent(VendasDataset);
    VendasDatasetpet_vendas_id.Name := 'VendasDatasetpet_vendas_id';
    VendasDatasetpet_vendas_id.FieldName := 'pet_vendas_id';
    VendasDatasetpet_prontuarios_id.SetParentComponent(VendasDataset);
    VendasDatasetpet_prontuarios_id.Name := 'VendasDatasetpet_prontuarios_id';
    VendasDatasetpet_prontuarios_id.FieldName := 'pet_prontuarios_id';
    VendasDatasetdata_entrega.SetParentComponent(VendasDataset);
    VendasDatasetdata_entrega.Name := 'VendasDatasetdata_entrega';
    VendasDatasetdata_entrega.FieldName := 'data_entrega';
    VendasDatasetdata_entrega.DisplayFormat := 'dd/mm/yy';
    VendasDatasetdata_movimento.SetParentComponent(VendasDataset);
    VendasDatasetdata_movimento.Name := 'VendasDatasetdata_movimento';
    VendasDatasetdata_movimento.FieldName := 'data_movimento';
    VendasDatasetdata_movimento.DisplayFormat := 'dd/mm/yy';
    VendasDatasetnome_consumidor_final.SetParentComponent(VendasDataset);
    VendasDatasetnome_consumidor_final.Name := 'VendasDatasetnome_consumidor_final';
    VendasDatasetnome_consumidor_final.FieldName := 'nome_consumidor_final';
    VendasDatasetnome_consumidor_final.Size := 255;
    VendasDatasetrotas_id.SetParentComponent(VendasDataset);
    VendasDatasetrotas_id.Name := 'VendasDatasetrotas_id';
    VendasDatasetrotas_id.FieldName := 'rotas_id';
    VendasDatasetconvenios_id.SetParentComponent(VendasDataset);
    VendasDatasetconvenios_id.Name := 'VendasDatasetconvenios_id';
    VendasDatasetconvenios_id.FieldName := 'convenios_id';
    VendasDatasetdependentes_id.SetParentComponent(VendasDataset);
    VendasDatasetdependentes_id.Name := 'VendasDatasetdependentes_id';
    VendasDatasetdependentes_id.FieldName := 'dependentes_id';
    VendasDatasetemissao_terceiros.SetParentComponent(VendasDataset);
    VendasDatasetemissao_terceiros.Name := 'VendasDatasetemissao_terceiros';
    VendasDatasetemissao_terceiros.FieldName := 'emissao_terceiros';
    VendasDatasetemissao_terceiros.Required := True;
    VendasDatasetchave_acesso_terceiros.SetParentComponent(VendasDataset);
    VendasDatasetchave_acesso_terceiros.Name := 'VendasDatasetchave_acesso_terceiros';
    VendasDatasetchave_acesso_terceiros.FieldName := 'chave_acesso_terceiros';
    VendasDatasetchave_acesso_terceiros.Size := 255;
    VendasDatasetmensalidade_id.SetParentComponent(VendasDataset);
    VendasDatasetmensalidade_id.Name := 'VendasDatasetmensalidade_id';
    VendasDatasetmensalidade_id.FieldName := 'mensalidade_id';
    VendasDatasetcodigo_producao.SetParentComponent(VendasDataset);
    VendasDatasetcodigo_producao.Name := 'VendasDatasetcodigo_producao';
    VendasDatasetcodigo_producao.FieldName := 'codigo_producao';
    VendasDatasetcodigo_producao.Size := 255;
    VendasDatasetsimples_faturamento.SetParentComponent(VendasDataset);
    VendasDatasetsimples_faturamento.Name := 'VendasDatasetsimples_faturamento';
    VendasDatasetsimples_faturamento.FieldName := 'simples_faturamento';
    VendasDatasetsimples_faturamento.Required := True;
    VendasDatasetvalor_icms_desonerado.SetParentComponent(VendasDataset);
    VendasDatasetvalor_icms_desonerado.Name := 'VendasDatasetvalor_icms_desonerado';
    VendasDatasetvalor_icms_desonerado.FieldName := 'valor_icms_desonerado';
    VendasDatasetvalor_icms_desonerado.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_ipi_devolucao.SetParentComponent(VendasDataset);
    VendasDatasetvalor_ipi_devolucao.Name := 'VendasDatasetvalor_ipi_devolucao';
    VendasDatasetvalor_ipi_devolucao.FieldName := 'valor_ipi_devolucao';
    VendasDatasetvalor_ipi_devolucao.DisplayFormat := '#,##0.000';
    VendasDatasetexcluiu_icms_base_pis_cofins.SetParentComponent(VendasDataset);
    VendasDatasetexcluiu_icms_base_pis_cofins.Name := 'VendasDatasetexcluiu_icms_base_pis_cofins';
    VendasDatasetexcluiu_icms_base_pis_cofins.FieldName := 'excluiu_icms_base_pis_cofins';
    VendasDatasetexcluiu_icms_base_pis_cofins.Required := True;
    VendasDatasetvalor_fcp_st.SetParentComponent(VendasDataset);
    VendasDatasetvalor_fcp_st.Name := 'VendasDatasetvalor_fcp_st';
    VendasDatasetvalor_fcp_st.FieldName := 'valor_fcp_st';
    VendasDatasetvalor_fcp_st.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_retido_pis.SetParentComponent(VendasDataset);
    VendasDatasetvalor_retido_pis.Name := 'VendasDatasetvalor_retido_pis';
    VendasDatasetvalor_retido_pis.FieldName := 'valor_retido_pis';
    VendasDatasetvalor_retido_pis.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_retido_cofins.SetParentComponent(VendasDataset);
    VendasDatasetvalor_retido_cofins.Name := 'VendasDatasetvalor_retido_cofins';
    VendasDatasetvalor_retido_cofins.FieldName := 'valor_retido_cofins';
    VendasDatasetvalor_retido_cofins.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_retido_csll.SetParentComponent(VendasDataset);
    VendasDatasetvalor_retido_csll.Name := 'VendasDatasetvalor_retido_csll';
    VendasDatasetvalor_retido_csll.FieldName := 'valor_retido_csll';
    VendasDatasetvalor_retido_csll.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_base_calculo_irrf.SetParentComponent(VendasDataset);
    VendasDatasetvalor_base_calculo_irrf.Name := 'VendasDatasetvalor_base_calculo_irrf';
    VendasDatasetvalor_base_calculo_irrf.FieldName := 'valor_base_calculo_irrf';
    VendasDatasetvalor_base_calculo_irrf.DisplayFormat := '#,##0.00';
    VendasDatasetaliquota_irrf.SetParentComponent(VendasDataset);
    VendasDatasetaliquota_irrf.Name := 'VendasDatasetaliquota_irrf';
    VendasDatasetaliquota_irrf.FieldName := 'aliquota_irrf';
    VendasDatasetaliquota_irrf.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_retido_irrf.SetParentComponent(VendasDataset);
    VendasDatasetvalor_retido_irrf.Name := 'VendasDatasetvalor_retido_irrf';
    VendasDatasetvalor_retido_irrf.FieldName := 'valor_retido_irrf';
    VendasDatasetvalor_retido_irrf.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_base_calculo_previdencia_social.SetParentComponent(VendasDataset);
    VendasDatasetvalor_base_calculo_previdencia_social.Name := 'VendasDatasetvalor_base_calculo_previdencia_social';
    VendasDatasetvalor_base_calculo_previdencia_social.FieldName := 'valor_base_calculo_previdencia_social';
    VendasDatasetvalor_base_calculo_previdencia_social.DisplayFormat := '#,##0.00';
    VendasDatasetaliquota_previdencia_social.SetParentComponent(VendasDataset);
    VendasDatasetaliquota_previdencia_social.Name := 'VendasDatasetaliquota_previdencia_social';
    VendasDatasetaliquota_previdencia_social.FieldName := 'aliquota_previdencia_social';
    VendasDatasetaliquota_previdencia_social.DisplayFormat := '#,##0.00';
    VendasDatasetvalor_previdencia_social.SetParentComponent(VendasDataset);
    VendasDatasetvalor_previdencia_social.Name := 'VendasDatasetvalor_previdencia_social';
    VendasDatasetvalor_previdencia_social.FieldName := 'valor_previdencia_social';
    VendasDatasetvalor_previdencia_social.DisplayFormat := '#,##0.00';
    VendasDatasetexcluiu_fcp_base_pis_cofins.SetParentComponent(VendasDataset);
    VendasDatasetexcluiu_fcp_base_pis_cofins.Name := 'VendasDatasetexcluiu_fcp_base_pis_cofins';
    VendasDatasetexcluiu_fcp_base_pis_cofins.FieldName := 'excluiu_fcp_base_pis_cofins';
    VendasDatasetexcluiu_fcp_base_pis_cofins.Required := True;
    VendasDatasetcodigo_interno.SetParentComponent(VendasDataset);
    VendasDatasetcodigo_interno.Name := 'VendasDatasetcodigo_interno';
    VendasDatasetcodigo_interno.FieldName := 'codigo_interno';
    VendasDatasetcodigo_interno.Required := True;
    VendasDatasetexcluido.SetParentComponent(VendasDataset);
    VendasDatasetexcluido.Name := 'VendasDatasetexcluido';
    VendasDatasetexcluido.FieldName := 'excluido';
    VendasDatasetinclusao.SetParentComponent(VendasDataset);
    VendasDatasetinclusao.Name := 'VendasDatasetinclusao';
    VendasDatasetinclusao.FieldName := 'inclusao';
    VendasDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    VendasDatasetalteracao.SetParentComponent(VendasDataset);
    VendasDatasetalteracao.Name := 'VendasDatasetalteracao';
    VendasDatasetalteracao.FieldName := 'alteracao';
    VendasDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    VendasDatasetexclusao.SetParentComponent(VendasDataset);
    VendasDatasetexclusao.Name := 'VendasDatasetexclusao';
    VendasDatasetexclusao.FieldName := 'exclusao';
    VendasDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    VendasDatasetfuncionarionome.SetParentComponent(VendasDataset);
    VendasDatasetfuncionarionome.Name := 'VendasDatasetfuncionarionome';
    VendasDatasetfuncionarionome.FieldName := 'funcionario.nome';
    VendasDatasetfuncionarionome.Size := 0;
    VendasDatasetclienterazao_social_nome.SetParentComponent(VendasDataset);
    VendasDatasetclienterazao_social_nome.Name := 'VendasDatasetclienterazao_social_nome';
    VendasDatasetclienterazao_social_nome.FieldName := 'cliente.razao_social_nome';
    VendasDatasetcfopnome.SetParentComponent(VendasDataset);
    VendasDatasetcfopnome.Name := 'VendasDatasetcfopnome';
    VendasDatasetcfopnome.FieldName := 'cfop.nome';
    VendasDatasetnfechave_acesso.SetParentComponent(VendasDataset);
    VendasDatasetnfechave_acesso.Name := 'VendasDatasetnfechave_acesso';
    VendasDatasetnfechave_acesso.FieldName := 'nfe.chave_acesso';
    VendasDatasetnfenfe_cancelada.SetParentComponent(VendasDataset);
    VendasDatasetnfenfe_cancelada.Name := 'VendasDatasetnfenfe_cancelada';
    VendasDatasetnfenfe_cancelada.FieldName := 'nfe.nfe_cancelada';
    VendasDatasetnfenfe_transmissao.SetParentComponent(VendasDataset);
    VendasDatasetnfenfe_transmissao.Name := 'VendasDatasetnfenfe_transmissao';
    VendasDatasetnfenfe_transmissao.FieldName := 'nfe.nfe_transmissao';
    VendasDatasetnfenfe_transmissao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    XDataClientVendasGet.SetParentComponent(Self);
    XDataClientVendasGet.Name := 'XDataClientVendasGet';
    XDataClientVendasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientVendasGet, Self, 'OnLoad', 'XDataClientVendasGetLoad');
    XDataClientVendasGet.Left := 912;
    XDataClientVendasGet.Top := 304;
    cdsItens.SetParentComponent(Self);
    cdsItens.Name := 'cdsItens';
    cdsItens.EntitySetName := 'Itens_Saida';
    cdsItens.Connection := DMConnection.ApiConnection;
    cdsItens.Left := 88;
    cdsItens.Top := 461;
    cdsItensproduto_id.SetParentComponent(cdsItens);
    cdsItensproduto_id.Name := 'cdsItensproduto_id';
    cdsItensproduto_id.Tag := 1;
    cdsItensproduto_id.FieldName := 'produto_id';
    cdsItensproduto_id.Required := True;
    cdsItensitem.SetParentComponent(cdsItens);
    cdsItensitem.Name := 'cdsItensitem';
    cdsItensitem.FieldName := 'item';
    SetEvent(cdsItensitem, Self, 'OnGetText', 'cdsItensitemGetText');
    cdsItensquantidade.SetParentComponent(cdsItens);
    cdsItensquantidade.Name := 'cdsItensquantidade';
    cdsItensquantidade.FieldName := 'quantidade';
    cdsItensquantidade.DisplayFormat := '#,##0.000';
    cdsItensproduto_preco.SetParentComponent(cdsItens);
    cdsItensproduto_preco.Name := 'cdsItensproduto_preco';
    cdsItensproduto_preco.FieldName := 'produto_preco';
    cdsItensproduto_preco.DisplayFormat := '#,##0.00';
    cdsItensvalor_total.SetParentComponent(cdsItens);
    cdsItensvalor_total.Name := 'cdsItensvalor_total';
    cdsItensvalor_total.FieldName := 'valor_total';
    cdsItensvalor_total.Required := True;
    cdsItensvalor_total.DisplayFormat := '#,##0.00';
    cdsItensprodnome.SetParentComponent(cdsItens);
    cdsItensprodnome.Name := 'cdsItensprodnome';
    cdsItensprodnome.FieldName := 'prod.nome';
    cdsItensprodcodigo_interno.SetParentComponent(cdsItens);
    cdsItensprodcodigo_interno.Name := 'cdsItensprodcodigo_interno';
    cdsItensprodcodigo_interno.FieldName := 'prod.codigo_interno';
    cdsItensunidadesigla.SetParentComponent(cdsItens);
    cdsItensunidadesigla.Name := 'cdsItensunidadesigla';
    cdsItensunidadesigla.FieldName := 'unidade.sigla';
    dtsItens.SetParentComponent(Self);
    dtsItens.Name := 'dtsItens';
    dtsItens.DataSet := cdsItens;
    dtsItens.Left := 32;
    dtsItens.Top := 461;
    tmrConsultaItens.SetParentComponent(Self);
    tmrConsultaItens.Name := 'tmrConsultaItens';
    tmrConsultaItens.Enabled := False;
    SetEvent(tmrConsultaItens, Self, 'OnTimer', 'tmrConsultaItensTimer');
    tmrConsultaItens.Left := 152;
    tmrConsultaItens.Top := 464;
    cdsRecebimentos.SetParentComponent(Self);
    cdsRecebimentos.Name := 'cdsRecebimentos';
    cdsRecebimentos.EntitySetName := 'Recebimentos';
    cdsRecebimentos.Connection := DMConnection.ApiConnection;
    cdsRecebimentos.QueryTop := 10;
    cdsRecebimentos.Left := 546;
    cdsRecebimentos.Top := 475;
    cdsRecebimentosvalor_bruto_recebido.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosvalor_bruto_recebido.Name := 'cdsRecebimentosvalor_bruto_recebido';
    cdsRecebimentosvalor_bruto_recebido.FieldName := 'valor_bruto_recebido';
    cdsRecebimentosvalor_bruto_recebido.DisplayFormat := '#,##0.00';
    cdsRecebimentosdata_recebimento.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosdata_recebimento.Name := 'cdsRecebimentosdata_recebimento';
    cdsRecebimentosdata_recebimento.FieldName := 'data_recebimento';
    cdsRecebimentosdata_recebimento.DisplayFormat := 'dd/mm/yy';
    cdsRecebimentosmodalidadenome.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosmodalidadenome.Name := 'cdsRecebimentosmodalidadenome';
    cdsRecebimentosmodalidadenome.FieldName := 'modalidade.nome';
    cdsRecebimentosareceberdocumento.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosareceberdocumento.Name := 'cdsRecebimentosareceberdocumento';
    cdsRecebimentosareceberdocumento.FieldName := 'areceber.documento';
    SetEvent(cdsRecebimentosareceberdocumento, Self, 'OnGetText', 'cdsRecebimentosareceberdocumentoGetText');
    cdsRecebimentosareceberparcela.SetParentComponent(cdsRecebimentos);
    cdsRecebimentosareceberparcela.Name := 'cdsRecebimentosareceberparcela';
    cdsRecebimentosareceberparcela.FieldName := 'areceber.parcela';
    dtsRecebimentos.SetParentComponent(Self);
    dtsRecebimentos.Name := 'dtsRecebimentos';
    dtsRecebimentos.DataSet := cdsRecebimentos;
    dtsRecebimentos.Left := 634;
    dtsRecebimentos.Top := 475;
    dtsAReceber.SetParentComponent(Self);
    dtsAReceber.Name := 'dtsAReceber';
    dtsAReceber.DataSet := cdsAReceber;
    dtsAReceber.Left := 384;
    dtsAReceber.Top := 480;
    cdsAReceber.SetParentComponent(Self);
    cdsAReceber.Name := 'cdsAReceber';
    cdsAReceber.EntitySetName := 'Areceber';
    cdsAReceber.Connection := DMConnection.ApiConnection;
    cdsAReceber.Left := 312;
    cdsAReceber.Top := 480;
    cdsAReceberdocumento.SetParentComponent(cdsAReceber);
    cdsAReceberdocumento.Name := 'cdsAReceberdocumento';
    cdsAReceberdocumento.FieldName := 'documento';
    SetEvent(cdsAReceberdocumento, Self, 'OnGetText', 'cdsAReceberdocumentoGetText');
    cdsAReceberdocumento.Size := 255;
    cdsAReceberparcela.SetParentComponent(cdsAReceber);
    cdsAReceberparcela.Name := 'cdsAReceberparcela';
    cdsAReceberparcela.FieldName := 'parcela';
    cdsAReceberparcela.Size := 255;
    cdsAReceberemissao.SetParentComponent(cdsAReceber);
    cdsAReceberemissao.Name := 'cdsAReceberemissao';
    cdsAReceberemissao.FieldName := 'emissao';
    cdsAReceberemissao.DisplayFormat := 'dd/mm/yy';
    cdsARecebervencimento.SetParentComponent(cdsAReceber);
    cdsARecebervencimento.Name := 'cdsARecebervencimento';
    cdsARecebervencimento.FieldName := 'vencimento';
    cdsARecebervencimento.Required := True;
    cdsARecebervencimento.DisplayFormat := 'dd/mm/yy';
    cdsARecebervalor_total.SetParentComponent(cdsAReceber);
    cdsARecebervalor_total.Name := 'cdsARecebervalor_total';
    cdsARecebervalor_total.FieldName := 'valor_total';
    cdsARecebervalor_total.Required := True;
    cdsARecebervalor_total.DisplayFormat := '#,##0.00';
    cdsARecebervalor_saldo_pendente.SetParentComponent(cdsAReceber);
    cdsARecebervalor_saldo_pendente.Name := 'cdsARecebervalor_saldo_pendente';
    cdsARecebervalor_saldo_pendente.FieldName := 'valor_saldo_pendente';
    cdsARecebervalor_saldo_pendente.DisplayFormat := '#,##0.00';
    cdsARecebervalor_pago.SetParentComponent(cdsAReceber);
    cdsARecebervalor_pago.Name := 'cdsARecebervalor_pago';
    cdsARecebervalor_pago.FieldName := 'valor_pago';
    cdsARecebervalor_pago.DisplayFormat := '#,##0.00';
  finally
    lbid.AfterLoadDFMValues;
    lbcliente_id.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    lbcaixa.AfterLoadDFMValues;
    lbcfop_cfop.AfterLoadDFMValues;
    lbnumero.AfterLoadDFMValues;
    lbdoc_auxiliar.AfterLoadDFMValues;
    lbmodelo.AfterLoadDFMValues;
    lbserie.AfterLoadDFMValues;
    lbsubserie.AfterLoadDFMValues;
    lbdata_emissao.AfterLoadDFMValues;
    lbdata_saida.AfterLoadDFMValues;
    lbvalor_acrescimos.AfterLoadDFMValues;
    lbvalor_descontos.AfterLoadDFMValues;
    lbvalor_base_calculo_icms.AfterLoadDFMValues;
    lbvalor_icms.AfterLoadDFMValues;
    lbvalor_base_calculo_st.AfterLoadDFMValues;
    lbvalor_st.AfterLoadDFMValues;
    lbvalor_seguro.AfterLoadDFMValues;
    lbvalor_frete.AfterLoadDFMValues;
    lbvalor_ipi.AfterLoadDFMValues;
    lbvalor_outras.AfterLoadDFMValues;
    lbvalor_total_itens.AfterLoadDFMValues;
    lbvalor_total.AfterLoadDFMValues;
    lbvolumes_quantidade.AfterLoadDFMValues;
    lbvolumes_especie.AfterLoadDFMValues;
    lbvolumes_marca.AfterLoadDFMValues;
    lbvolumes_peso_bruto.AfterLoadDFMValues;
    lbvolumes_peso_liquido.AfterLoadDFMValues;
    lbfrete_por_conta.AfterLoadDFMValues;
    lbobservacoes_credito.AfterLoadDFMValues;
    lbobservacoes.AfterLoadDFMValues;
    lbnota_situacao.AfterLoadDFMValues;
    lbipi_compoe_base_icms.AfterLoadDFMValues;
    lbfrete_compoe_base_icms.AfterLoadDFMValues;
    lbseguro_compoe_base_icms.AfterLoadDFMValues;
    lboutras_compoe_base_icms.AfterLoadDFMValues;
    lbvalor_isentas.AfterLoadDFMValues;
    lbdata_entrega.AfterLoadDFMValues;
    lbdata_movimento.AfterLoadDFMValues;
    lbemissao_terceiros.AfterLoadDFMValues;
    lbchave_acesso_terceiros.AfterLoadDFMValues;
    lbsimples_faturamento.AfterLoadDFMValues;
    lbvalor_icms_desonerado.AfterLoadDFMValues;
    lbvalor_ipi_devolucao.AfterLoadDFMValues;
    lbexcluiu_icms_base_pis_cofins.AfterLoadDFMValues;
    lbvalor_fcp_st.AfterLoadDFMValues;
    lbvalor_retido_pis.AfterLoadDFMValues;
    lbvalor_retido_cofins.AfterLoadDFMValues;
    lbvalor_retido_csll.AfterLoadDFMValues;
    lbvalor_base_calculo_irrf.AfterLoadDFMValues;
    lbaliquota_irrf.AfterLoadDFMValues;
    lbvalor_retido_irrf.AfterLoadDFMValues;
    lbvalor_base_calculo_previdencia_social.AfterLoadDFMValues;
    lbaliquota_previdencia_social.AfterLoadDFMValues;
    lbvalor_previdencia_social.AfterLoadDFMValues;
    lbexcluiu_fcp_base_pis_cofins.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbPaginationInfoItens.AfterLoadDFMValues;
    lbPaginationInfoAReceber.AfterLoadDFMValues;
    lbPaginationInfoRecebimentos.AfterLoadDFMValues;
    lbchave_acesso.AfterLoadDFMValues;
    lbnfe_transmissao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edcliente_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    edcaixa.AfterLoadDFMValues;
    edcfop_cfop.AfterLoadDFMValues;
    ednumero.AfterLoadDFMValues;
    eddoc_auxiliar.AfterLoadDFMValues;
    edmodelo.AfterLoadDFMValues;
    edserie.AfterLoadDFMValues;
    edsubserie.AfterLoadDFMValues;
    eddata_emissao.AfterLoadDFMValues;
    eddata_saida.AfterLoadDFMValues;
    edvalor_acrescimos.AfterLoadDFMValues;
    edvalor_descontos.AfterLoadDFMValues;
    edvalor_base_calculo_icms.AfterLoadDFMValues;
    edvalor_icms.AfterLoadDFMValues;
    edvalor_base_calculo_st.AfterLoadDFMValues;
    edvalor_st.AfterLoadDFMValues;
    edvalor_seguro.AfterLoadDFMValues;
    edvalor_frete.AfterLoadDFMValues;
    edvalor_ipi.AfterLoadDFMValues;
    edvalor_outras.AfterLoadDFMValues;
    edvalor_total_itens.AfterLoadDFMValues;
    edvalor_total.AfterLoadDFMValues;
    edvolumes_quantidade.AfterLoadDFMValues;
    edvolumes_especie.AfterLoadDFMValues;
    edvolumes_marca.AfterLoadDFMValues;
    edvolumes_peso_bruto.AfterLoadDFMValues;
    edvolumes_peso_liquido.AfterLoadDFMValues;
    edfrete_por_conta.AfterLoadDFMValues;
    edobservacoes_credito.AfterLoadDFMValues;
    edobservacoes.AfterLoadDFMValues;
    ednota_situacao.AfterLoadDFMValues;
    edvalor_isentas.AfterLoadDFMValues;
    eddata_entrega.AfterLoadDFMValues;
    eddata_movimento.AfterLoadDFMValues;
    edchave_acesso_terceiros.AfterLoadDFMValues;
    edvalor_icms_desonerado.AfterLoadDFMValues;
    edvalor_ipi_devolucao.AfterLoadDFMValues;
    edvalor_fcp_st.AfterLoadDFMValues;
    edvalor_retido_pis.AfterLoadDFMValues;
    edvalor_retido_cofins.AfterLoadDFMValues;
    edvalor_retido_csll.AfterLoadDFMValues;
    edvalor_base_calculo_irrf.AfterLoadDFMValues;
    edaliquota_irrf.AfterLoadDFMValues;
    edvalor_retido_irrf.AfterLoadDFMValues;
    edvalor_base_calculo_previdencia_social.AfterLoadDFMValues;
    edaliquota_previdencia_social.AfterLoadDFMValues;
    edvalor_previdencia_social.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxipi_compoe_base_icms.AfterLoadDFMValues;
    cbxfrete_compoe_base_icms.AfterLoadDFMValues;
    cbxseguro_compoe_base_icms.AfterLoadDFMValues;
    cbxoutras_compoe_base_icms.AfterLoadDFMValues;
    cbxexcluiu_icms_base_pis_cofins.AfterLoadDFMValues;
    cbxexcluiu_fcp_base_pis_cofins.AfterLoadDFMValues;
    cbxsimples_faturamento.AfterLoadDFMValues;
    cbxemissao_terceiros.AfterLoadDFMValues;
    pnlFormDados.AfterLoadDFMValues;
    tblItens.AfterLoadDFMValues;
    cbPageSizeItens.AfterLoadDFMValues;
    edSearchItens.AfterLoadDFMValues;
    pnlItensPromocao.AfterLoadDFMValues;
    btnItensTab.AfterLoadDFMValues;
    lcPaginatorItens.AfterLoadDFMValues;
    pnlTabelaAReceber.AfterLoadDFMValues;
    tblAReceber.AfterLoadDFMValues;
    lcPaginatorAReceber.AfterLoadDFMValues;
    tblRecebimentos.AfterLoadDFMValues;
    pnlTabelaPagamentos.AfterLoadDFMValues;
    btnFinanceiroTab.AfterLoadDFMValues;
    btnRecebimentosTab.AfterLoadDFMValues;
    lcPaginatorRecebimentos.AfterLoadDFMValues;
    pnlFormNfe.AfterLoadDFMValues;
    edchave_acesso.AfterLoadDFMValues;
    ednfe_transmissao.AfterLoadDFMValues;
    btnCopiarChaveAcesso.AfterLoadDFMValues;
    btnNfeTab.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    VendasDataset.AfterLoadDFMValues;
    VendasDatasetid.AfterLoadDFMValues;
    VendasDatasetaliado_id.AfterLoadDFMValues;
    VendasDatasetdata_base_id.AfterLoadDFMValues;
    VendasDatasetcliente_id.AfterLoadDFMValues;
    VendasDatasetfuncionario_id.AfterLoadDFMValues;
    VendasDatasetcaixa.AfterLoadDFMValues;
    VendasDatasetcfop_cfop.AfterLoadDFMValues;
    VendasDatasetnumero.AfterLoadDFMValues;
    VendasDatasetdoc_auxiliar.AfterLoadDFMValues;
    VendasDatasetmodelo.AfterLoadDFMValues;
    VendasDatasetserie.AfterLoadDFMValues;
    VendasDatasetsubserie.AfterLoadDFMValues;
    VendasDatasetdata_emissao.AfterLoadDFMValues;
    VendasDatasetdata_saida.AfterLoadDFMValues;
    VendasDatasetvalor_acrescimos.AfterLoadDFMValues;
    VendasDatasetvalor_descontos.AfterLoadDFMValues;
    VendasDatasetvalor_base_calculo_icms.AfterLoadDFMValues;
    VendasDatasetvalor_icms.AfterLoadDFMValues;
    VendasDatasetvalor_base_calculo_st.AfterLoadDFMValues;
    VendasDatasetvalor_st.AfterLoadDFMValues;
    VendasDatasetvalor_seguro.AfterLoadDFMValues;
    VendasDatasetvalor_frete.AfterLoadDFMValues;
    VendasDatasetvalor_ipi.AfterLoadDFMValues;
    VendasDatasetvalor_outras.AfterLoadDFMValues;
    VendasDatasetvalor_total_itens.AfterLoadDFMValues;
    VendasDatasetvalor_total.AfterLoadDFMValues;
    VendasDatasettransportadora_id.AfterLoadDFMValues;
    VendasDatasetplaca_veiculo.AfterLoadDFMValues;
    VendasDatasetvolumes_quantidade.AfterLoadDFMValues;
    VendasDatasetvolumes_especie.AfterLoadDFMValues;
    VendasDatasetvolumes_marca.AfterLoadDFMValues;
    VendasDatasetvolumes_peso_bruto.AfterLoadDFMValues;
    VendasDatasetvolumes_peso_liquido.AfterLoadDFMValues;
    VendasDatasetfrete_por_conta.AfterLoadDFMValues;
    VendasDatasetobservacoes_credito.AfterLoadDFMValues;
    VendasDatasetobservacoes.AfterLoadDFMValues;
    VendasDatasetnota_situacao.AfterLoadDFMValues;
    VendasDatasetipi_compoe_base_icms.AfterLoadDFMValues;
    VendasDatasetfrete_compoe_base_icms.AfterLoadDFMValues;
    VendasDatasetseguro_compoe_base_icms.AfterLoadDFMValues;
    VendasDatasetoutras_compoe_base_icms.AfterLoadDFMValues;
    VendasDatasetvalor_isentas.AfterLoadDFMValues;
    VendasDatasetcliente_fidelidade_id.AfterLoadDFMValues;
    VendasDatasetnfe_id.AfterLoadDFMValues;
    VendasDatasetnfse_id.AfterLoadDFMValues;
    VendasDatasetosv_oss_id.AfterLoadDFMValues;
    VendasDatasetose_oss_id.AfterLoadDFMValues;
    VendasDatasetorcamentos_id.AfterLoadDFMValues;
    VendasDatasetpet_vendas_id.AfterLoadDFMValues;
    VendasDatasetpet_prontuarios_id.AfterLoadDFMValues;
    VendasDatasetdata_entrega.AfterLoadDFMValues;
    VendasDatasetdata_movimento.AfterLoadDFMValues;
    VendasDatasetnome_consumidor_final.AfterLoadDFMValues;
    VendasDatasetrotas_id.AfterLoadDFMValues;
    VendasDatasetconvenios_id.AfterLoadDFMValues;
    VendasDatasetdependentes_id.AfterLoadDFMValues;
    VendasDatasetemissao_terceiros.AfterLoadDFMValues;
    VendasDatasetchave_acesso_terceiros.AfterLoadDFMValues;
    VendasDatasetmensalidade_id.AfterLoadDFMValues;
    VendasDatasetcodigo_producao.AfterLoadDFMValues;
    VendasDatasetsimples_faturamento.AfterLoadDFMValues;
    VendasDatasetvalor_icms_desonerado.AfterLoadDFMValues;
    VendasDatasetvalor_ipi_devolucao.AfterLoadDFMValues;
    VendasDatasetexcluiu_icms_base_pis_cofins.AfterLoadDFMValues;
    VendasDatasetvalor_fcp_st.AfterLoadDFMValues;
    VendasDatasetvalor_retido_pis.AfterLoadDFMValues;
    VendasDatasetvalor_retido_cofins.AfterLoadDFMValues;
    VendasDatasetvalor_retido_csll.AfterLoadDFMValues;
    VendasDatasetvalor_base_calculo_irrf.AfterLoadDFMValues;
    VendasDatasetaliquota_irrf.AfterLoadDFMValues;
    VendasDatasetvalor_retido_irrf.AfterLoadDFMValues;
    VendasDatasetvalor_base_calculo_previdencia_social.AfterLoadDFMValues;
    VendasDatasetaliquota_previdencia_social.AfterLoadDFMValues;
    VendasDatasetvalor_previdencia_social.AfterLoadDFMValues;
    VendasDatasetexcluiu_fcp_base_pis_cofins.AfterLoadDFMValues;
    VendasDatasetcodigo_interno.AfterLoadDFMValues;
    VendasDatasetexcluido.AfterLoadDFMValues;
    VendasDatasetinclusao.AfterLoadDFMValues;
    VendasDatasetalteracao.AfterLoadDFMValues;
    VendasDatasetexclusao.AfterLoadDFMValues;
    VendasDatasetfuncionarionome.AfterLoadDFMValues;
    VendasDatasetclienterazao_social_nome.AfterLoadDFMValues;
    VendasDatasetcfopnome.AfterLoadDFMValues;
    VendasDatasetnfechave_acesso.AfterLoadDFMValues;
    VendasDatasetnfenfe_cancelada.AfterLoadDFMValues;
    VendasDatasetnfenfe_transmissao.AfterLoadDFMValues;
    XDataClientVendasGet.AfterLoadDFMValues;
    cdsItens.AfterLoadDFMValues;
    cdsItensproduto_id.AfterLoadDFMValues;
    cdsItensitem.AfterLoadDFMValues;
    cdsItensquantidade.AfterLoadDFMValues;
    cdsItensproduto_preco.AfterLoadDFMValues;
    cdsItensvalor_total.AfterLoadDFMValues;
    cdsItensprodnome.AfterLoadDFMValues;
    cdsItensprodcodigo_interno.AfterLoadDFMValues;
    cdsItensunidadesigla.AfterLoadDFMValues;
    dtsItens.AfterLoadDFMValues;
    tmrConsultaItens.AfterLoadDFMValues;
    cdsRecebimentos.AfterLoadDFMValues;
    cdsRecebimentosvalor_bruto_recebido.AfterLoadDFMValues;
    cdsRecebimentosdata_recebimento.AfterLoadDFMValues;
    cdsRecebimentosmodalidadenome.AfterLoadDFMValues;
    cdsRecebimentosareceberdocumento.AfterLoadDFMValues;
    cdsRecebimentosareceberparcela.AfterLoadDFMValues;
    dtsRecebimentos.AfterLoadDFMValues;
    dtsAReceber.AfterLoadDFMValues;
    cdsAReceber.AfterLoadDFMValues;
    cdsAReceberdocumento.AfterLoadDFMValues;
    cdsAReceberparcela.AfterLoadDFMValues;
    cdsAReceberemissao.AfterLoadDFMValues;
    cdsARecebervencimento.AfterLoadDFMValues;
    cdsARecebervalor_total.AfterLoadDFMValues;
    cdsARecebervalor_saldo_pendente.AfterLoadDFMValues;
    cdsARecebervalor_pago.AfterLoadDFMValues;
  end;
end;

end.
